// Autogenerated from file 'GenerateAPITS.cs'. DO NOT MODIFY
// Number of Classes: 611 Enums: 100 Structs: 126
// =============================================================================
// Yodiwo Warlock - Plegma APIs
// =============================================================================

//----------------------------------------------- 
export module Plegma {
  export const enum Boolean_Format {
    TrueFalse = 0,
    OnOff = 1,
    YesNo = 2,
    EnabledDisabled = 3,
    EnableDisable = 4,
    ActiveInactive = 5,
    ActivateDeactivate = 6,
    ActivatedDeactivated = 7
  }
  export const enum eA2mcuCtrlType {
    Reset = 0,
    SetValue = 1,
    WriteDriconf = 2
  }
  export const enum eBinaryResourceContentType {
    Undefined = 0,
    Data = 1,
    Text = 2,
    Image = 3,
    Audio = 4,
    Video = 5
  }
  export const enum eBinaryResourceLocationType {
    Undefined = 0,
    Http = 1,
    RedisDB = 2
  }
  export const enum eConnectionFlags {
    None = 0,
    CreateNewEndpoint = 1,
    IsMasterEndpoint = 2,
    KillExistingNodeLinks = 4
  }
  export const enum eConnStatus {
    NONE = 0,
    RX_ON = 1,
    TX_ON = 2,
    ALL = 3
  }
  export const enum eDriverType {
    Unknown = 0,
    LCD = 1
  }
  export const enum eEndpointRestrictions {
    None = 0,
    SkipThingsSync = 1,
    SkipPortStateSync = 2,
    DelayRxPathOpen = 4
  }
  export const enum eLinkType {
    Unknown = 0,
    YPC = 1,
    WebSocket = 2,
    Mqtt = 3,
    Rmq = 4,
    Fcm = 5,
    REST = 11
  }
  export const enum eMsgFlags {
    None = 0,
    Request = 1,
    Response = 2
  }
  export const enum eNodeCapa {
    None = 0,
    SupportsGraphSolving = 1,
    Scannable = 2,
    IsWarlock = 4,
    IsShellNode = 8
  }
  export const enum eNodeEventType {
    Connected = 0,
    Disconnected = 1,
    RxEnabled = 2,
    RxDisabled = 3,
    ConnectFailure = 4,
    DisconnectReq = 5
  }
  export const enum eNodeNewStatus {
    Unpaired = 0,
    Disabled = 1,
    Enabled = 2
  }
  export const enum eNodeStatusChangeReason {
    Unknown = 0,
    InvalidOperation = 1,
    UserRequested = 2,
    TooManyAuthFailures = 4,
    QuotaRelated = 8,
    Temporary = 16
  }
  export const enum eNodeSyncOperation {
    GetEndpoints = 1,
    SetEndpoint = 2
  }
  export const enum eNodeType {
    Unknown = 0,
    Generic = 1,
    EndpointSingle = 2,
    TestGateway = 3,
    TestEndpoint = 4,
    WSEndpoint = 5,
    Android = 6,
    iOS = 7,
    SmartThingsEndPoint = 8,
    mNode = 9,
    Dashboard = 10,
    LoRa = 11,
    Impact = 12,
    ImpactV2 = 13,
    Facebook = 14,
    Skype = 15,
    Sigfox = 16,
    WSSample = 200,
    RestSample = 201,
    Virtual = 202,
    Yodikit = 203
  }
  export const enum ePortConf {
    None = 0,
    PropagateAllEvents = 1,
    IsTrigger = 2,
    DoNotNormalize = 4,
    SupressIdenticalEvents = 8,
    Hidden = 16,
    IsMetadata = 32
  }
  export const enum ePortStateOperation {
    Invalid = 0,
    SpecificKeys = 1,
    ActivePortStates = 2,
    AllPortStates = 3,
    ActivePortKeys = 4,
    AllPortsNoStates = 5
  }
  export enum ePortType {
    Undefined = 0,
    Integer = 1,
    Decimal = 2,
    DecimalHigh = 3,
    Boolean = 4,
    Color = 5,
    String = 6,
    VideoDescriptor = 7,
    AudioDescriptor = 8,
    BinaryResourceDescriptor = 9,
    I2CDescriptor = 10,
    JsonString = 11,
    IncidentDescriptor = 12,
    Timestamp = 13
  }
  export const enum eRecurrence {
    Once = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3
  }
  export const enum eRspStatusCode {
    OK = 0,
    ThingIsNotCurrentlyConnected = 4,
    Invalid = 6,
    Unreachable = 7,
    NoEligibleTarget = 8,
    RejectedDueToQuota = 12,
    RejectedDueToThrottling = 13,
    LastReserved = 29,
    OtherError = 255
  }
  export const enum eThingConf {
    None = 0,
    SyncEventWithAllEndpoints = 1,
    Removable = 2
  }
  export const enum eThingSolveErrorCode {
    Received = 0,
    Sent = 1,
    Forwarded = 2,
    ThingDoesNotExist = 3,
    ThingIsNotCurrentlyConnected = 4,
    NoPendingReqFound = 5,
    InvalidReq = 6,
    Unreachable = 7,
    NoEligibleTarget = 8,
    TimeToLiveExceeded = 9,
    RejectedByThirdParty = 10,
    FateUnknown = 11,
    RejectedDueToQuota = 12,
    RejectedDueToThrottling = 13,
    LastReserved = 29,
    OtherError = 255
  }
  export const enum eThingsOperation {
    Invalid = 0,
    Update = 1,
    Overwrite = 2,
    Delete = 3,
    Get = 4,
    Scan = 5,
    Sync = 6
  }
  export const enum eUnpairReason {
    Unknown = 0,
    InvalidOperation = 1,
    UserRequested = 2,
    TooManyAuthFailures = 3
  }
  export const enum eWSMsgId {
    None = 0,
    Pairing = 1,
    Api = 2,
    Warlock = 3
  }
  export const enum ImageFileFormat {
    Undefined = 0,
    PNG = 1,
    TIFF = 2,
    GIF = 3,
    BMP = 4,
    SVG = 5
  }
  export const enum ImageType {
    Raster = 0,
    Vector = 1
  }
  export const enum ioPortDirection {
    Undefined = 0,
    InputOutput = 1,
    Output = 2,
    Input = 3
  }
  export const enum PairingStates {
    Initial = 0,
    StartRequested = 1,
    TokensRequested = 2,
    TokensSentToNode = 3,
    Token2SentToUser = 4,
    Token2PostedToServer = 5,
    UUIDEntryRedirect = 6,
    Phase1Complete = 7,
    NextRequested = 8,
    Token1PostedToServer = 9,
    KeysSentToNode = 10,
    Paired = 11,
    Failed = 12
  }
  export const enum ReminderType {
    Single = 0,
    Multiple = 1
  }
  export const enum RestServiceType {
    Undefined = 0,
    Dropbox = 1,
    Pastebin = 2,
    GoogleDrive = 3,
    Yodiwo = 4
  }
  export const enum String_Case {
    None = 0,
    Lower = 1,
    Upper = 2
  }
  export interface A2mcuActiveDriver {
    BlockKey?: string;
    Deinit?: Plegma.A2mcuSequencedCommands;
    DriverKey?: string;
    Init?: Plegma.A2mcuSequencedCommands;
    ThingKey?: string;
  }
  export interface A2mcuActiveDriversReq extends Plegma.PlegmaApiMsg {
    ActiveDrivers?: Plegma.A2mcuActiveDriver[];
  }
  export interface A2mcuConcurrent {
  }
  export interface A2mcuConcurrentCommands extends Plegma.A2mcuConcurrent {
    CtrlMsgs?: Plegma.A2mcuCtrl[];
  }
  export interface A2mcuConfigConstants {
  }
  export interface A2mcuCtrl extends Plegma.A2mcuConcurrent {
    BlockKey?: string;
    Data?: any;
    ThingKey?: string;
    Type?: Plegma.eA2mcuCtrlType;
  }
  export interface A2mcuCtrlReq extends Plegma.PlegmaApiMsg {
    CtrlMsgs?: Plegma.A2mcuCtrl[];
  }
  export interface A2mcuSequencedCommands {
    Seq?: Plegma.A2mcuConcurrent[];
  }
  export interface ActivePortKeysMsg extends Plegma.PlegmaApiMsg {
    ActivePortKeys?: string[];
  }
  export interface AudioContentDescriptor extends Plegma.ContentDescriptor {
  }
  export interface BinaryResourceDescriptor {
    AutoDelete?: boolean;
    ContentDescriptorJson?: string;
    ContentType?: Plegma.eBinaryResourceContentType;
    DueDate?: number;
    DueDateStr?: string;
    FriendlyDescription?: string;
    FriendlyName?: string;
    Key?: string;
    LastFetched?: number;
    LastFetchedStr?: string;
    LocationDescriptorJson?: string;
    LocationType?: Plegma.eBinaryResourceLocationType;
    MaxFetchTimes?: number;
    Size?: number;
    TimesFetched?: number;
  }
  export interface BinaryResourceDescriptorKey {
    Id?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface BinaryResourceHelper {
  }
  export interface BlockEventFeedbackMsg extends Plegma.GenericRsp {
    BlockKey?: Plegma.BlockKey;
    Id?: number;
    StatusCode?: Plegma.eThingSolveErrorCode;
    ThingKey?: Plegma.ThingKey;
  }
  export interface BlockKey {
    BlockId?: number;
    GraphKey?: Plegma.GraphKey;
  }
  export interface ConfigDescription {
    DefaultValue?: string;
    Description?: string;
    Label?: string;
    Maximum?: number;
    Minimum?: number;
    Name?: string;
    ReadOnly?: boolean;
    Required?: boolean;
    Stepsize?: number;
    Type?: string;
  }
  export interface ConfigParameter {
    Description?: string;
    Name?: string;
    Value?: string;
  }
  export interface Constants {
  }
  export interface ContentDescriptor {
    ContentType?: string;
    Data?: any;
  }
  export interface DataContentDescriptor extends Plegma.ContentDescriptor {
  }
  export interface DbKey {
    Id?: string;
    KeyMagic?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface Decimal_Range {
    Max?: number;
    Min?: number;
  }
  export interface DriverKey {
    Id?: number;
    Type?: Plegma.eDriverType;
  }
  export interface EndpointSyncReq extends Plegma.PlegmaApiMsg {
    DesiredEndpoint?: string;
    op?: Plegma.eNodeSyncOperation;
  }
  export interface EndpointSyncRsp extends Plegma.PlegmaApiMsg {
    Accepted?: boolean;
    Endpoints?: string[];
    op?: Plegma.eNodeSyncOperation;
  }
  export interface EvBlockSolve extends Plegma.EvSolveCommon {
    BlockKey?: Plegma.BlockKey;
  }
  export interface EvGraphSolve extends Plegma.EvSolveCommon {
    GraphKey?: Plegma.GraphKey;
  }
  export interface EvNodeApiFendCommon extends Plegma.EvNodeCommon {
    EndpointKey?: string;
    EventType?: Plegma.eNodeEventType;
    LinkType?: Plegma.eLinkType;
    RawLinkKey?: string;
  }
  export interface EvNodeCommon extends Yodiwo.API.EvCommon {
    Name?: string;
    NodeKey?: Plegma.NodeKey;
  }
  export interface EvNodeConnectAttemptFailure extends Plegma.EvNodeApiFendCommon {
  }
  export interface EvNodeConnected extends Plegma.EvNodeApiFendCommon {
    IpAddress?: string;
  }
  export interface EvNodeDisconnected extends Plegma.EvNodeApiFendCommon {
  }
  export interface EvNodeDisconnectReq extends Plegma.EvNodeApiFendCommon {
  }
  export interface EvNodeRxDisabled extends Plegma.EvNodeApiFendCommon {
  }
  export interface EvNodeRxEnabled extends Plegma.EvNodeApiFendCommon {
  }
  export interface EvSolveCommon {
    exceptions?: boolean;
    start?: boolean;
    timestamp?: Date;
  }
  export interface ExternalServiceBlockKey {
    BlockID?: string;
    ServiceID?: string;
    Userkey?: Plegma.UserKey;
  }
  export interface FcmConnectionMsg {
    NodeKey?: string;
    RegistrationId?: string;
  }
  export interface FcmDisconnectionMsg {
    RegistrationId?: string;
  }
  export interface GraphDeploymentReq extends Plegma.PlegmaApiMsg {
    GraphDescriptor?: string;
    GraphKey?: string;
    IsDeployed?: boolean;
  }
  export interface GraphDescriptorBaseKey {
    Id?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface GraphDescriptorKey {
    BaseKey?: Plegma.GraphDescriptorBaseKey;
    Revision?: number;
  }
  export interface GraphKey {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    NodeId?: number;
  }
  export interface GraphOptions {
    ForceToStateful?: boolean;
    RestrictToSession?: boolean;
  }
  export interface GroupKey {
    GroupID?: number;
    KeyMagic?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface HelperExtensions {
  }
  export interface HttpLocationDescriptor extends Plegma.LocationDescriptor {
    RestServiceType?: Plegma.RestServiceType;
    Uri?: string;
  }
  export interface I2CCommand {
    devaddress?: number;
    IsWrite?: boolean;
    ReadLength?: number;
    register?: number;
    value?: number[];
  }
  export interface ImageContentDescriptor extends Plegma.ContentDescriptor {
    ColorDepth?: number;
    Format?: Plegma.ImageFileFormat;
    PixelSizeX?: number;
    PixelSizeY?: number;
    Type?: Plegma.ImageType;
  }
  export interface Integer_Range {
    Max?: number;
    Min?: number;
  }
  export interface LocallyDeployedGraphsMsg extends Plegma.PlegmaApiMsg {
    DeployedGraphKeys?: string[];
  }
  export interface LocationDescriptor {
  }
  export interface LoginReq extends Plegma.PlegmaApiMsg {
  }
  export interface LoginRsp extends Plegma.PlegmaApiMsg {
    DesiredEndpoint?: string;
    Flags?: Plegma.eConnectionFlags;
    NodeKey?: string;
    SecretKey?: string;
  }
  export interface NodeInfoReq extends Plegma.PlegmaApiMsg {
    AssignedEndpoint?: string;
    LatestApiRev?: number;
    ThingsRevNum?: number;
  }
  export interface NodeInfoRsp extends Plegma.PlegmaApiMsg {
    AdditionalInfo?: { [key: string]: string };
    BlockLibraries?: string[];
    Capabilities?: Plegma.eNodeCapa;
    MaxMsgSize?: number;
    Name?: string;
    Restrictions?: Plegma.eEndpointRestrictions;
    SupportedApiRev?: number;
    ThingsRevNum?: number;
    ThingTypes?: Plegma.ThingType[];
    TransientInfo?: { [key: string]: string };
    Type?: Plegma.eNodeType;
  }
  export interface NodeKey {
    NodeID?: number;
    UserKey?: Plegma.UserKey;
  }
  export interface NodeLinkIpInfo {
    ConnectionTimestamp?: Date;
    EndpointKey?: string;
    ExternalIP?: string;
    InternalIP?: string;
    LinkType?: Plegma.eLinkType;
    RawLinkKey?: string;
  }
  export interface NodeStatusChangedReq extends Plegma.PlegmaApiMsg {
    Message?: string;
    NewStatus?: Plegma.eNodeNewStatus;
    Nodekey?: Plegma.NodeKey;
    ReasonCode?: Plegma.eNodeStatusChangeReason;
  }
  export interface NodeUnpairedReq extends Plegma.PlegmaApiMsg {
    Message?: string;
    Nodekey?: Plegma.NodeKey;
    ReasonCode?: Plegma.eUnpairReason;
  }
  export interface PairingNodeGetKeysRequest {
    token1?: string;
    token2?: string;
  }
  export interface PairingNodeGetTokensRequest {
    description?: string;
    image?: string;
    name?: string;
    NoUUIDAuthentication?: boolean;
    PairingCompletionInstructions?: string;
    pathcss?: string;
    PublicKey?: number[];
    RedirectUri?: string;
    TargetEmail?: string;
    uuid?: string;
  }
  export interface PairingServerKeysResponse extends Plegma.GenericRsp {
    email?: string;
    nodeKey?: string;
    secretKey?: string;
  }
  export interface PairingServerTokensResponse extends Plegma.GenericRsp {
    token1?: string;
    token2?: string;
  }
  export interface PingReq extends Plegma.PlegmaApiMsg {
    Data?: number;
  }
  export interface PingRsp extends Plegma.PlegmaApiMsg {
    Data?: number;
  }
  export interface PlegmaAPI {
    ApiMessages?: any[];
    ApiMsgNames?: { [key: string]: string };
    ApiMsgNamesToTypes?: { [key: string]: string };
    ApiMsgRetained?: { [key: string]: boolean };
    LogicApiMessages?: any[];
  }
  export interface PlegmaApiMsg extends Yodiwo.API.ApiMsg {
  }
  export interface Port {
    Color?: string;
    ConfFlags?: Plegma.ePortConf;
    Description?: string;
    ioDirection?: Plegma.ioPortDirection;
    LastUpdatedTimestamp?: number;
    Name?: string;
    PortKey?: string;
    PortModelId?: string;
    RevNum?: number;
    Semantics?: string;
    Size?: number;
    State?: string;
    Touch?: any;
    Type?: Plegma.ePortType;
    Yport?: any;
  }
  export interface PortDescription {
    Category?: string;
    Description?: string;
    Id?: string;
    ioDirection?: Plegma.ioPortDirection;
    Label?: string;
    Semantics?: string;
    State?: Plegma.StateDescription;
  }
  export interface PortEvent {
    PortKey?: string;
    RevNum?: number;
    State?: string;
    Timestamp?: number;
  }
  export interface PortEventMsg extends Plegma.PlegmaApiMsg {
    BlockKey?: string;
    INeedAck?: boolean;
    PortEvents?: Plegma.PortEvent[];
  }
  export interface PortEventReq extends Plegma.PortEventMsg {
  }
  export interface PortEventRsp extends Plegma.PortEventMsg {
    IsSuccess?: boolean;
    Message?: string;
  }
  export interface PortKey {
    PortUID?: string;
    ThingKey?: Plegma.ThingKey;
  }
  export interface PortModelLibrary {
  }
  export interface PortState {
    IsDeployed?: boolean;
    PortKey?: string;
    RevNum?: number;
    State?: string;
  }
  export interface PortStateGet extends Plegma.PlegmaApiMsg {
    Operation?: Plegma.ePortStateOperation;
    PortKeys?: string[];
  }
  export interface PortStateSemantics {
  }
  export interface PortStateSet extends Plegma.PlegmaApiMsg {
    Operation?: Plegma.ePortStateOperation;
    PortStates?: Plegma.PortState[];
  }
  export interface RedisDBLocationDescriptor extends Plegma.LocationDescriptor {
    ConnectionAddress?: string;
    DatabaseName?: string;
  }
  export interface ScheduleKey {
    KeyMagic?: string;
    ScheduleID?: number;
    UserKey?: Plegma.UserKey;
  }
  export interface StateDescription {
    Maximum?: number;
    Minimum?: number;
    Pattern?: string;
    ReadOnly?: boolean;
    Step?: number;
    Type?: Plegma.ePortType;
  }
  export interface SubUserKey {
    UserKey?: Plegma.UserKey;
  }
  export interface TextContentDescriptor extends Plegma.ContentDescriptor {
  }
  export interface Thing {
    ConfFlags?: Plegma.eThingConf;
    Config?: Plegma.ConfigParameter[];
    Hierarchy?: string;
    Name?: string;
    Ports?: Plegma.Port[];
    ReadonlyInfo?: Plegma.ConfigParameter[];
    Removable?: boolean;
    RESTUri?: string;
    ThingKey?: string;
    Type?: string;
    UIHints?: Plegma.ThingUIHints;
    Ything?: any;
  }
  export interface ThingExtensions {
  }
  export interface ThingKey {
    NodeKey?: Plegma.NodeKey;
    SpikeSeparator?: string;
    ThingUID?: string;
  }
  export interface ThingModelType {
    Config?: Plegma.ConfigDescription[];
    Description?: string;
    Id?: string;
    Name?: string;
    NumPorts?: { [key: string]: number };
    PortModels?: { [key: string]: Plegma.PortDescription };
  }
  export interface ThingsGet extends Plegma.PlegmaApiMsg {
    Key?: string;
    Operation?: Plegma.eThingsOperation;
    RevNum?: number;
    ThingKey?: string;
  }
  export interface ThingsSet extends Plegma.PlegmaApiMsg {
    Data?: Plegma.Thing[];
    Hierarchy?: string;
    Operation?: Plegma.eThingsOperation;
    RevNum?: number;
    Status?: boolean;
  }
  export interface ThingType {
    Description?: string;
    Models?: { [key: string]: Plegma.ThingModelType };
    Searchable?: boolean;
    Type?: string;
  }
  export interface ThingTypeLibrary {
    AndroidIntent?: Plegma.ThingType;
    BeaconDetector?: Plegma.ThingType;
    Bluetooth?: Plegma.ThingType;
    Button?: Plegma.ThingType;
    Buzzer?: Plegma.ThingType;
    Camera?: Plegma.ThingType;
    DataPlotter?: Plegma.ThingType;
    Displayer?: Plegma.ThingType;
    FleetMgr?: Plegma.ThingType;
    Flickr?: Plegma.ThingType;
    Gallery?: Plegma.ThingType;
    Gpio?: Plegma.ThingType;
    Label?: Plegma.ThingType;
    Lcd?: Plegma.ThingType;
    Lights?: Plegma.ThingType;
    Location?: Plegma.ThingType;
    Microphone?: Plegma.ThingType;
    Nfc?: Plegma.ThingType;
    RegionViewer?: Plegma.ThingType;
    Seekbar?: Plegma.ThingType;
    Sensors?: Plegma.ThingType;
    SipPhone?: Plegma.ThingType;
    SpeechRecognition?: Plegma.ThingType;
    Switches?: Plegma.ThingType;
    Text?: Plegma.ThingType;
    Text2Speech?: Plegma.ThingType;
    Type2ThingType?: { [key: string]: Plegma.ThingType };
    WifiInfo?: Plegma.ThingType;
  }
  export interface ThingTypes {
  }
  export interface ThingTypesMigrator {
    OldTypeToNewType?: { [key: string]: string };
  }
  export interface ThingUIHints {
    Description?: string;
    IconURI?: string;
  }
  export interface UserApiKey {
    ApiUID?: string;
    Userkey?: Plegma.UserKey;
  }
  export interface UserKey {
    UserID?: string;
  }
  export interface VideoContentDescriptor extends Plegma.ContentDescriptor {
  }
  export interface VirtualBlockEvent {
    BlockKey?: string;
    Indices?: number[];
    RevNum?: number;
    Values?: string[];
  }
  export interface VirtualBlockEventMsg extends Plegma.PlegmaApiMsg {
    BlockEvents?: Plegma.VirtualBlockEvent[];
  }
  export interface WebSocketMsg extends Yodiwo.WrapperMsg {
    Id?: Plegma.eWSMsgId;
    SubId?: string;
  }
  export interface YColor {
    A?: number;
    B?: number;
    G?: number;
    R?: number;
  }
}
//----------------------------------------------- 
export module Services {
  export const enum DevReqType {
    Reboot = 0,
    FactoryReset = 1,
    UpdateConfig = 2,
    SystemCmd = 3,
    ExecuteScript = 4
  }
  export const enum eAnalyticsType {
    Detect_Faces = 1,
    Detect_Text = 2,
    Detect_Document_Text = 4,
    Detect_Labels = 8,
    Detect_Landmarks = 16,
    Detect_Logos = 32,
    Extract_Safe_Search_Tags = 64,
    Image_Property_Processing = 128,
    Suggest_Crop_Hints = 256,
    Find_Web_References = 512
  }
  export const enum eBanReasonCode {
    FeltLikeIt = 0,
    FromAdminConsole = 1,
    TooManyPenalties = 2
  }
  export const enum eDirection {
    None = 0,
    Uplink = 1,
    Downlink = 2,
    Both = 3
  }
  export const enum eEventType {
    JoinAccepted = 0,
    JoinRejected = 1
  }
  export const enum eEventType {
    GatewayLost = 0,
    GatewayFound = 1
  }
  export const enum eLoraProvider {
    Yodiwo = 0,
    Talkpool = 1,
    Ttn = 2,
    Senet = 3,
    Senra = 4,
    EveryNet = 5
  }
  export const enum eMsgTypes {
    AnchorEvent = 0,
    AnchorTrackedTagsReq = 1,
    AnchorTrackedTagsRsp = 2,
    AnchorConfigMsg = 3,
    VisUpdateWidgetAssetTrackerAssets = 4,
    VisUpdateWidgetAssetTrackerGateways = 5,
    VisUpdateWidgetTableAssets = 6
  }
  export const enum eNKEBatchUncompressSampleType {
    ST_UNDEF = 0,
    ST_BL = 1,
    ST_U4 = 2,
    ST_I4 = 3,
    ST_U8 = 4,
    ST_I8 = 5,
    ST_U16 = 6,
    ST_I16 = 7,
    ST_U24 = 8,
    ST_I24 = 9,
    ST_U32 = 10,
    ST_I32 = 11,
    ST_FL = 12
  }
  export const enum ePayloadEncoding {
    base64 = 0,
    hexstring = 1
  }
  export const enum eProvisionType {
    OTAA = 0,
    ABP = 1
  }
  export const enum eServiceType {
    Lora = 0,
    Impact = 1,
    Facebook = 2,
    Skype = 3,
    Video = 4,
    Audio = 5,
    ExtBlockService = 6,
    Sigfox = 7,
    DevMgmt = 8,
    DialogEK = 9,
    Onboarding = 10,
    Yodifinder = 11,
    NBIOT = 12,
    FacilityMgmt = 13
  }
  export const enum eTxWindowPreference {
    Tx1 = 0,
    Tx2 = 1
  }
  export const enum eVehicle {
    Car = 0,
    Bus = 1,
    Bicycle = 2,
    Moto = 3
  }
  export const enum eWasteType {
    Mixed = 0,
    Glass = 1,
    Paper = 2,
    Plastic = 3
  }
  export const enum ProtocolCommand {
    Registration = 0,
    Data = 1
  }
  export const enum ServiceType {
    Lora = 0,
    Impact = 1,
    Facebook = 2,
    Skype = 3,
    Video = 4,
    Audio = 5,
    ExtBlockService = 6,
    Sigfox = 7,
    DevMgmt = 8,
    DialogEK = 9,
    Onboarding = 10,
    Yodifinder = 11,
    NBIOT = 12,
    FacilityMgmt = 13
  }
  export interface AddDeviceRequest {
    AssignedWorker?: string;
    IMEI?: string;
    Nodekey?: string;
    Userkey?: string;
  }
  export interface AddEndpointReq {
    ImpactPassword?: string;
    ImpactUname?: string;
    ImpactUniqueKey?: Services.ImpactKey;
    ImpactUrl?: string;
    nodekey?: Plegma.NodeKey;
  }
  export interface AddEndpointResp {
    ImpactKey?: Services.ImpactKey;
    Things?: Plegma.Thing[];
  }
  export interface AddFbUserReq {
    fbemail?: string;
    PageName?: string;
    PIN?: string;
    Userkey?: string;
  }
  export interface AddFbUserRsp {
    isValid?: boolean;
    Message?: string;
    PIN?: string;
    PSID?: string;
    UserKey?: string;
  }
  export interface AddSkypeUserReq {
    PIN?: string;
    SkypeBot?: string;
    Skypeemail?: string;
    Userkey?: string;
    Worker?: string;
  }
  export interface AddSkypeUserRsp {
    BSID?: string;
    isValid?: boolean;
    Message?: string;
    PIN?: string;
    UserKey?: string;
  }
  export interface air_quality {
    barometer?: number;
    co?: number;
    co2?: number;
    humidity?: number;
    no?: number;
    no2?: number;
    o3?: number;
    pm1?: number;
    pm10?: number;
    pm2_5?: number;
    so2?: number;
    temperature?: number;
  }
  export interface AnchorConfigMsg {
    ForceSendAfterSecs?: number;
    Operation?: number;
    RssiDelta?: number;
    TrackedTags?: string[];
    TrackedTagsUpdatePeriod?: number;
  }
  export interface AnchorEvent {
    BatVolt?: number;
    GwId?: string;
    IsOnAlert?: boolean;
    LastRssi?: number;
    TagId?: string;
  }
  export interface AnchorTrackedTagsReq {
  }
  export interface AnchorTrackedTagsRsp {
    TagIds?: string[];
  }
  export interface AppConfig {
    /* NOTE */
    /* This need to be add by hand*/
    AppEui: string;
    AppName: string;
    AppKey: string;
    AppType: eLoraProvider;
    Talkpool: TalkpoolAppInfo;
    Everynet: EverynetAppInfo;
    Ttn: TtnAppInfo;
    Senet: SenetAppInfo;
    UserKey: string;
    NodeKey: string;
  }
  export interface AsyncDevMgmtResponse extends Services.DeviceMgmt.GenericRsp {
    DevReqType?: Services.DevReqType;
  }
  export interface AudioExtraInfo {
    MP3ServerPort?: number;
    SecureYPC?: boolean;
    YAudioServerPort?: number;
  }
  export interface AudioMgmt {
  }
  export interface ConfigNames {
    AppEuiParam?: string;
    AppKeyParam?: string;
    AppSKeyParam?: string;
    BridgeProtocol?: string;
    ConfirmedDownlink?: string;
    DevAddrParam?: string;
    DevEuiParam?: string;
    DevTypeParam?: string;
    DnlinkPayloadEncoding?: string;
    EverynetApiKey?: string;
    IsClassC?: string;
    NetworSKParam?: string;
    PasswordParam?: string;
    TTL?: string;
    TxApiKey?: string;
    UplinkPayloadEncoding?: string;
    UsernameParam?: string;
  }
  export interface ConfigNames {
    DevIdParam?: string;
    DevNameParam?: string;
    DevTypeNameParam?: string;
    DevTypeParam?: string;
    DevTypeUrlParam?: string;
    GroupIdParam?: string;
    PasswordParam?: string;
    UsernameParam?: string;
  }
  export interface CountersOpts {
    DownlinkCnt?: number;
    TriggerRejoin?: boolean;
    UplinkCnt?: number;
  }
  export interface Credentials {
    password?: string;
    username?: string;
  }
  export interface DeleteEndpointReq {
    ImpactKey?: string;
    NodeKey?: string;
  }
  export interface DeleteFbUserReq {
    fbemail?: string;
    PIN?: string;
    PSID?: string;
    Userkey?: string;
  }
  export interface DeleteSkypeUserReq {
    BSID?: string;
    PIN?: string;
    skypeemail?: string;
    Userkey?: string;
  }
  export interface DeleteSubscriptionsReq {
    subscriptionids?: string[];
  }
  export interface DeviceConfig {
    AppSKey?: string;
    ConfirmedDownlinks?: boolean;
    DecryptionInNS?: boolean;
    DeviceEui?: string;
    Direction?: Services.eDirection;
    DownlinkDefaultEncoding?: Services.ePayloadEncoding;
    DownlinkRxDelay?: Services.eTxWindowPreference;
    FrameCounter16bit?: boolean;
    IsClassC?: boolean;
    JoinAcceptRxDelay?: Services.eTxWindowPreference;
    LastDownlinkTs?: string;
    LastSessionTs?: string;
    LastUplinkTs?: string;
    Meta?: Services.Metadata;
    Name?: string;
    NwAddr?: string;
    NwSKey?: string;
    OnboardingTs?: string;
    ProvisioningType?: Services.eProvisionType;
    Ttl?: number;
    Type?: string;
    UplinkDefaultEncoding?: Services.ePayloadEncoding;
    UserKey?: string;
  }
  export interface DeviceConfigReq {
    AppConfig?: Services.AppConfig;
    DeviceConfig?: Services.DeviceConfig;
  }
  export interface DeviceMgmt {
  }
  export interface DevMgmtRequest {
    AssignedWorker?: string;
    jsonmsg?: string;
    NeedsAsyncResponse?: boolean;
    RemoteCtrlType?: Services.DevReqType;
    TokenId?: string;
    UniqueId?: string;
  }
  export interface energy {
    frequency?: number;
    p1?: Services.energy_single;
    p2?: Services.energy_single;
    p3?: Services.energy_single;
    pf?: number;
    total?: Services.energy_single;
  }
  export interface energy_single {
    kva?: number;
    kvar?: number;
    kvarh?: number;
    kvarh_diff?: number;
    kw?: number;
    kwh?: number;
    kwh_diff?: number;
  }
  export interface env {
    co?: number;
    co2?: number;
    humidity?: number;
    temperature?: number;
  }
  export interface EverynetAppInfo {
    /* NOTE */
    /* This need to be add by hand*/
    Token?: string;
    FilterId?: string;
  }
  export interface EvUserAccountLevelUpdated extends Services.EvUserCommon {
    AccountLevel?: number;
  }
  export interface EvUserBanned extends Services.EvUserCommon {
    ReasonCode?: Services.eBanReasonCode;
    ReasonMsg?: string;
  }
  export interface EvUserCommon extends Yodiwo.API.EvCommon {
    UserEmail?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface EvUserCreated extends Services.EvUserCommon {
  }
  export interface EvUserEjected extends Services.EvUserCommon {
  }
  export interface EvUserParked extends Services.EvUserCommon {
  }
  export interface EvUserPrivilegeLevelUpdated extends Services.EvUserCommon {
    PrivelegeLevel?: Warlock.ePrivilegeLevel;
  }
  export interface EvUserRemoved extends Services.EvUserCommon {
  }
  export interface EvUserUnbanned extends Services.EvUserCommon {
  }
  export interface EvUserUnparked extends Services.EvUserCommon {
  }
  export interface EvWorkerCommon extends Yodiwo.API.EvCommon {
  }
  export interface EvWorkerInfo extends Services.EvWorkerCommon {
    ActiveCfgId?: string;
    Domain?: string;
    ExternalIPAddress?: string;
    InternalIPAddress?: string;
    MachineID?: string;
    MachineRole?: number;
    SupportedFeatures?: { [key: string]: string };
  }
  export interface EvWorkerStart extends Services.EvWorkerInfo {
  }
  export interface ExecuteScript {
    base64_scriptcontent?: string;
  }
  export interface ExtBlockLib {
  }
  export interface Facebook {
    addusertopic?: string;
    delusertopic?: string;
    getpageinfo?: string;
    msgtopic?: string;
  }
  export interface FacebookExtraInfo {
    AccessToken?: string;
    PageId?: string;
    PageName?: string;
    PageUrl?: string;
    version?: string;
  }
  export interface FacilityMgmt {
  }
  export interface FactoryReset {
    base_64_factoryrestjson?: string;
  }
  export interface gas_consumption {
    operatingAmount?: number;
    operatingDifference?: number;
  }
  export interface GetBotInfoReq {
    worker?: string;
  }
  export interface GetBotInfoRsp extends Plegma.GenericRsp {
    BotName?: string;
    ContactBotUrl?: string;
  }
  export interface GetPageInfoReq {
    worker?: string;
  }
  export interface GetPageInfoRsp extends Plegma.GenericRsp {
    PageName?: string;
    PageUrl?: string;
  }
  export interface GetResourcePathsRsp extends Services.Impact.GenericRsp {
    ResourcePaths?: { [key: string]: string[] };
  }
  export interface GetSubscribedPaths extends Services.Impact.GenericRsp {
    respaths?: string[];
  }
  export interface GoogleAnalytics {
  }
  export interface GoogleAnnotationReq {
    AnnotationType?: Services.eAnalyticsType;
    ImageUri?: string;
    SyncToken?: string;
  }
  export interface GoogleAnnotationRsp {
    JsonRsp?: string;
    Msg?: string;
    SyncToken?: string;
  }
  export interface GroupReq {
    IncludeSubgroups?: boolean;
    UserCreds?: Services.Credentials;
    UserKey?: string;
  }
  export interface IdPac {
    id?: string;
    pac?: string;
  }
  export interface Impact {
  }
  export interface ImpactCbRegistrationReq {
    ImpactPassword?: string;
    ImpactUname?: string;
    ImpactUrl?: string;
  }
  export interface ImpactCbRegistrationRsp {
    cbpassword?: string;
    cbuname?: string;
  }
  export interface ImpactCreateReq {
    GroupName?: string;
    ImpactPassword?: string;
    ImpactUname?: string;
    ImpactUrl?: string;
    UserKey?: string;
    worker?: string;
  }
  export interface ImpactDescriptor {
    AutomaticSubscription?: boolean;
    GroupName?: string;
    ImpactKey?: string;
    ImpactUname?: string;
    ImpactUrl?: string;
    IsGroup?: boolean;
    SerialNo?: string;
  }
  export interface ImpactEndpointCreateReq extends Services.ImpactCreateReq {
    AutomaticSubscription?: boolean;
    SerialNo?: string;
  }
  export interface ImpactGroupCreateReq extends Services.ImpactCreateReq {
  }
  export interface ImpactKey {
    Endpoint?: string;
    Group?: string;
  }
  export interface InOutMsg {
    PSID?: string;
    text?: string;
    Userkey?: string;
  }
  export interface InOutMsg {
    BSID?: string;
    text?: string;
    Userkey?: string;
  }
  export interface Location {
    Altitude?: string;
    Latitude?: string;
    Longitude?: string;
  }
  export interface LoRa {
  }
  export interface LoraMsg {
    Altitude?: string;
    DeviceEui?: string;
    EpochMilli?: number;
    Flags?: Services.UplinkFlags;
    FOptions?: string;
    Fport?: number;
    GwEui?: string;
    GwEvent?: Services.LoraMsgGwEvent;
    Latitude?: string;
    Longitude?: string;
    OtaaEvent?: Services.LoraMsgOtaaEvent;
    Payload?: string;
    Rssi?: number;
    Seq?: number;
    Snr?: number;
    Time?: string;
    TimeOnAir?: number;
    TxAck?: Services.LoraMsgTxAck;
    Uplink?: Services.LoraMsgUplink;
  }
  export interface LoraMsgDownlink {
    BlockKey?: string;
    FOptions?: number[];
    Fport?: number;
    Options?: Services.LoraMsgDownlinkOpts;
    Payload?: string;
    Seq?: number;
    Time?: Date;
  }
  export interface LoraMsgDownlinkOpts {
    BypassDutyCycleThisOneTime?: boolean;
    Confirmed?: boolean;
    Format?: Services.ePayloadEncoding;
    ResetCounters?: Services.CountersOpts;
    Ttl?: number;
  }
  export interface LoraMsgGwEvent {
    EvType?: Services.eEventType;
    Gweui?: string;
  }
  export interface LoraMsgOtaaEvent {
    Deveui?: string;
    EvType?: Services.eEventType;
    Meta?: Services.RadioParameters;
  }
  export interface LoraMsgTxAck extends Plegma.GenericRsp {
    BlockKey?: string;
    DevEui?: string;
    GwEui?: string;
    Seq?: number;
  }
  export interface LoraMsgUplink {
    DeviceEui?: string;
    Flags?: Services.UplinkFlags;
    FOptions?: string;
    Fport?: number;
    GwEui?: string;
    Meta?: Services.RadioParameters;
    NoOfGws?: number;
    Payload?: string;
    Seq?: number;
    Time?: string;
  }
  export interface measurement {
    energy?: Services.energy;
    env?: Services.env;
    epoch_msec?: number;
    gas_consumption?: Services.gas_consumption;
  }
  export interface measurement {
    airq?: Services.air_quality;
    epoch_msec?: number;
    lighting?: Services.smart_lighting;
    parking?: Services.smart_parking;
    traffic?: Services.smart_traffic;
    waste?: Services.waste_mgmt;
  }
  export interface Metadata {
    CID?: number;
    LastBW?: number;
    LastGwCount?: number;
    LastSF?: number;
  }
  export interface MongoConf {
    CollectionName?: string;
    DbName?: string;
  }
  export interface MqttConnDescriptor {
    BrokerHostname?: string;
    CertificateServerName?: string;
    ClientId?: string;
    Passwd?: string;
    Port?: number;
    Uname?: string;
    UseSsl?: boolean;
  }
  export interface MqttHelpers {
  }
  export interface NBIOT {
  }
  export interface NBIOTDescriptor {
    AssignedWorker?: string;
    IMEI?: string;
    Nodekey?: string;
    Userkey?: string;
  }
  export interface NBIOTMessage {
    IMEI?: string;
    Payload?: string;
  }
  export interface NKEBatchUncompressReq {
    Input?: number[];
    RxEpoch?: number;
    TagsConf?: Services.NKEBatchUncompressTagConf[];
    TagSize?: number;
  }
  export interface NKEBatchUncompressRsp {
    counter?: number;
    series?: Services.NKEBatchUncompressRspSeries[];
  }
  export interface NKEBatchUncompressRspSample {
    epoch?: number;
    timestamp?: Date;
    value?: string;
  }
  export interface NKEBatchUncompressRspSeries {
    sample_type?: number;
    samples?: Services.NKEBatchUncompressRspSample[];
    tag_label?: number;
  }
  export interface NKEBatchUncompressTagConf {
    lbl?: number;
    resolution?: number;
    st?: number;
  }
  export interface PortNames {
    DevEui?: string;
    FPortIn?: string;
    FPortOut?: string;
    OptionsOut?: string;
    PayloadIn?: string;
    PayloadOut?: string;
    WrapperIn?: string;
  }
  export interface PortNames {
    ConfirmedOut?: string;
    DevId?: string;
    FPortOut?: string;
    PayloadIn?: string;
    PayloadOut?: string;
    WrapperIn?: string;
  }
  export interface RadioParameters {
    Bw_khz?: number;
    CodingRate?: string;
    DataRate?: string;
    Fcnt?: number;
    Freq?: number;
    GwLocation?: Services.Location;
    Modu?: string;
    Rssi?: number;
    Sf?: number;
    Snr?: number;
    TimeOnAir?: number;
  }
  export interface RawMsg {
    data?: Services.measurement[];
  }
  export interface RawMsg {
    data?: Services.measurement[];
  }
  export interface RebootNode {
  }
  export interface RegisterManyReq {
    cert?: string;
    dev_type_id?: string;
    ids?: Services.IdPac[];
    prefix?: string;
    userkey?: string;
  }
  export interface RegisterOneReq {
    cert?: string;
    dev_type_id?: string;
    id?: string;
    pac?: string;
    prefix?: string;
    userkey?: string;
  }
  export interface RegisterResourceSubscriptions {
    ResourcePaths?: string[];
  }
  export interface RegistrationReq {
    GroupName?: string;
    SerialNo?: string;
  }
  export interface ReportResourceValue {
    ImpactKey?: Services.ImpactKey;
    portKeyPath?: Plegma.PortKey;
    portKeyValue?: Plegma.PortKey;
    resPath?: string;
    resValue?: string;
  }
  export interface RestRoutes {
  }
  export interface RestRoutes {
  }
  export interface RestRoutes {
  }
  export interface RestRoutes {
  }
  export interface RestStatusCodes {
  }
  export interface RMQConnDescriptor {
    BrokerHostname?: string;
    Password?: string;
    TargetCloudSet?: string;
    Username?: string;
    Usessl?: boolean;
    Virtualhost?: string;
  }
  export interface RMQServiceDescriptor {
    RMQConnDescriptor?: Services.RMQConnDescriptor;
  }
  export interface SenetAppInfo {
  }
  export interface ServiceDescriptor {
    AssignedWorker?: string;
    ExtraInfo?: any;
    MqttConnDescriptor?: Services.MqttConnDescriptor;
    RMQConnDescriptor?: Services.RMQConnDescriptor;
  }
  export interface SetResourceState {
    ImpactKey?: Services.ImpactKey;
    nodekey?: Plegma.NodeKey;
    Nodekey?: string;
    resPath?: string;
    State?: string;
  }
  export interface Sigfox {
    ThingType?: string;
  }
  export interface Skype {
    addusertopic?: string;
    delusertopic?: string;
    getbotinfo?: string;
    msgtopic?: string;
  }
  export interface SkypeExtraInfo {
    AddtoContactsUrl?: string;
    BotId?: string;
    BotName?: string;
    MsAppId?: string;
    MsAppSecret?: string;
  }
  export interface smart_lighting {
    dimmed_duration?: number;
    dimming_level?: number;
    kva?: number;
    kvar?: number;
    kvarh?: number;
    kw?: number;
    kwh?: number;
    max_dimming_level?: number;
    min_dimming_level?: number;
    off_duration?: number;
    on_duration?: number;
    pf?: number;
  }
  export interface smart_parking {
    batt?: number;
    is_occupied?: boolean;
    parking_id?: string;
    rssi?: number;
    state?: string;
    temp?: number;
    zone_id?: string;
  }
  export interface smart_traffic {
    destination?: number;
    source?: number;
    speed?: number;
    vehicle?: Services.eVehicle;
  }
  export interface SmartCity {
  }
  export interface SpryngSmsDeliveryReport {
    Reference?: string;
    Result?: string;
    UserKey?: string;
  }
  export interface SystemCmd {
    bashcmd?: string;
  }
  export interface TalkpoolAppInfo {
    UserCreds: Credentials;
  }
  export interface TalkpoolAppInfoPriv {
    MqttUserCreds: Credentials;
  }
  export interface ThingHelpers {
    ThingDefaultType?: string;
    ThingDefaultTypePrefix?: string;
  }
  export interface TpDeviceConfig {
    appSKey?: string;
    deviceEui?: string;
    name?: string;
    nwAddr?: string;
    nwSKey?: string;
    UserKey?: string;
  }
  export interface TtnAppInfo {
  }
  export interface TypedExtServiceWrapperMQTT extends Services.GenericExtServiceWrapperMQTT {
    MsgType?: any;
  }
  export interface UpdateConfig {
    ConfigPath?: string;
    jsonContent?: string;
  }
  export interface UplinkFlags {
    ClassB?: boolean;
    ExpectsAck?: boolean;
    IsAck?: boolean;
    IsAdrAckReq?: boolean;
    SupportsAdr?: boolean;
  }
  export interface VideoExtraInfo {
    MjpegServerPort?: number;
    SecureYPC?: boolean;
    YVideoServerPort?: number;
  }
  export interface VideoMgmt {
  }
  export interface waste_mgmt {
    filling_level?: number;
    type?: Services.eWasteType;
  }
  export interface WrapperMQTT extends Services.GenericExtServiceWrapperMQTT {
    BlockKey?: string;
  }
  export interface Yodifinder {
  }
  export interface YodifinderMsg {
    MsgPayload?: string;
    MsgType?: number;
  }
}
//----------------------------------------------- 
export module dummy_class1 {
  export interface KeyValuePair<TKey, TValue> {
  }
}
//----------------------------------------------- 
export module Warlock {
  export const enum eAllowedUserRole {
    None = 0,
    Production = 1,
    Staging = 2,
    DevMirror = 4,
    OnPremises = 8
  }
  export enum eApiKeyType {
    Rest = 0,
    Linked_To_Node = 1,
    BearerToken = 2,
    Warlock = 3
  }
  export const enum eARFamily {
    Invalid = 0,
    R_ADMINISTRATION = 1,
    R_APPLICATIONS = 2,
    R_INTRA_APP_MOVE = 4,
    R_CYAN_GRAPH = 1024,
    R_CYAN_APIKEY = 2048,
    R_CYAN_DEV = 4096,
    R_CYAN_SCH = 8192,
    R_CYAN_DB = 16384,
    R_CYAN_CONSTS = 32768,
    R_CYAN_FILE = 65536,
    R_EMERALD = 1048576,
    R_QUOTA = 1073741824
  }
  export const enum eARLayer {
    Asset = 0,
    Bundle = 10,
    App = 20,
    Tld = 30,
    Plt = 40
  }
  export const enum eARLevel {
    View = 0,
    Edit = 10,
    Delete = 20,
    Add = 30
  }
  export const enum eBlockEntity {
    Generic = 0,
    Thing = 1,
    Group = 2,
    Macro = 3,
    Service = 4
  }
  export const enum eBRDUpdateAction {
    Invalid = 0,
    Name = 1,
    AutoDelete = 2
  }
  export const enum eConstantType {
    Generic = 0,
    ConnectionString = 1
  }
  export const enum eDatabaseInfoReqType {
    INVALID_ACTION = 0,
    ADD_DATABASE = 1,
    ADD_USER = 2,
    DROP_DATABASE = 3,
    DROP_USER = 4,
    LINK = 5,
    UNLINK = 6,
    DATABASE_BLOCK_INFO = 7
  }
  export enum eDocumentationContentType {
    Text = 0,
    HTML = 1,
    XML = 2,
    CommonMark = 3
  }
  export enum eEntityType {
    Invalid = 0,
    Graph = 1,
    Node = 2,
    Thing = 3,
    Dashboard = 5,
    DashboardPage = 6,
    ApiKey = 7,
    Group = 8,
    User = 9,
    Schedule = 10,
    Const = 11,
    Quota = 12,
    DB = 13,
    DBUser = 14,
    File = 15,
    AppDomain = 50,
    Tld = 52,
    Platform = 54
  }
  export const enum eFoundThingsAction {
    None = 0,
    ShareAskAll = 1,
    UseMine = 2
  }
  export const enum eGraphActionType {
    Invalid = 0,
    Deploy = 1,
    Undeploy = 2,
    Validate = 3,
    Load = 4,
    Save = 5,
    Replace = 6,
    Copy = 7,
    Update = 8,
    Import = 9,
    Export = 10,
    Remove = 11,
    Info = 12,
    MacroBlockUIHints = 13,
    Share = 14,
    ExportAsMacroBlock = 15,
    Publish = 16,
    SaveOptions = 17,
    FolderAdd = 18,
    FolderRemove = 19,
    ValidateBlockConfiguration = 20
  }
  export const enum eLiveExecutionEventType {
    None = 0,
    Solve = 1,
    PortStates = 2
  }
  export const enum eLiveListenerType {
    None = 0,
    Blocks = 1,
    Graphs = 2,
    Ports = 3,
    All = 4
  }
  export const enum eMsgFlags {
    None = 0,
    Request = 1,
    Response = 2
  }
  export const enum eNodeDescriptorReqOrdering {
    None = 0,
    Name = 1,
    NodeKey = 2,
    Status = 3,
    Type = 4,
    Capabilities = 5,
    Permissions = 6,
    ThingsCount = 7
  }
  export const enum eNodeDescriptorReqThingsOrdering {
    None = 0,
    NodeName = 1,
    Name = 2,
    PortsCount = 3,
    ThingKey = 4,
    Type = 5,
    Hierarchy = 6,
    Shared = 7
  }
  export const enum eNodeFlags {
    None = 0,
    Disabled = 1,
    DefiesQuotaLimits = 2,
    NonPlegma = 4,
    ServiceNode = 8
  }
  export const enum eNodePermissions {
    NoPermissions = 0,
    AllowUserQueries = 1,
    AllowGraphCtrl = 2,
    AllowSharingCtrl = 4,
    AllowPermissionCtrl = 8,
    AllowCrossNodeMsgs = 16,
    AllowNodeCtrl = 32,
    AllPermissions = 63
  }
  export const enum eNodeStatus {
    Unknown = 0,
    Offline = 1,
    Online = 2,
    Maintenance = 3
  }
  export enum ePrivilegeLevel {
    Guest = 0,
    User = 1,
    PartialReadAdmin = 10,
    PartialWriteAdmin = 11,
    YodiReadAdmin = 99,
    YodiWriteAdmin = 101
  }
  export const enum eQuotaFlags {
    None = 0,
    MonotonicallyIncreasing = 1,
    NonResettable = 2,
    Informational = 4,
    NoAutoUpdates = 8
  }
  export enum eQuotaType {
    BytesIn = 0,
    BytesOut = 1,
    BytesIO = 2,
    EventsIn = 3,
    EventsOut = 4,
    EventsIO = 5,
    ApiKeysInUse = 6,
    Obsolete_ApiKeysTimesUsed = 7,
    DeployedGraphs = 8,
    Nodes = 9,
    Things = 10,
    Integrations = 11,
    EmailsSent = 12,
    TotalEmails = 13,
    Databases = 14,
    Storage = 15
  }
  export const enum eRestParameterType {
    Cookie = 0,
    GetOrPost = 1,
    UrlSegment = 2,
    HttpHeader = 3,
    RequestBody = 4,
    QueryString = 5
  }
  export const enum eRestRouteTypes {
    None = 0,
    FirstAuth = 1,
    SecondAuth = 2,
    TokenRefresh = 4,
    AuthorizedApiCall = 8,
    UnauthorizedApiCall = 16,
    GetRequestToken = 32
  }
  export const enum eRestServiceAuthTypes {
    None = 0,
    OAuth1 = 1,
    OAuth2 = 2,
    BasicAuthentication = 3
  }
  export const enum eRestServiceRouteMethod {
    GET = 0,
    POST = 1,
    PUT = 2,
    DELETE = 3,
    HEAD = 4,
    OPTIONS = 5,
    PATCH = 6,
    MERGE = 7
  }
  export enum eRichTextDescriptorLanguageDescriptor {
    csharp = 0,
    sql = 1,
    text = 2,
    javascript = 3
  }
  export const enum eSeverity {
    Info = 0,
    Warning = 1,
    Error = 2,
    Success = 3
  }
  export const enum eShareActionType {
    Share = 0,
    Unshare = 1,
    Ask = 2,
    AskAll = 3,
    Deny = 4,
    Accept = 5,
    Enable = 6,
    Disable = 7
  }
  export const enum eSharingOpts {
    Invalid = 0,
    AutoAcceptFromAll = 1,
    AlwaysAsk = 2,
    AlwaysDeny = 3
  }
  export enum eTimelineDescriptorOperationType {
    Unknown = 0,
    Add = 1,
    Remove = 2,
    UpdateOrEdit = 3,
    Enable = 4,
    Disable = 5,
    Deploy = 6,
    UndeployExplicit = 7,
    UndeployImplicit = 8,
    Share = 9,
    UnshareExplicit = 10,
    UnshareImplicit = 11,
    ShareToMe = 12,
    UnshareFromMe = 13,
    UnshareToMe = 14,
    Connected = 15,
    Disconnected = 16,
    ConnectFail = 17,
    QuotaLimitCrossed = 18,
    QuotaLimitUncrossed = 19,
    QuotaLimitChanged = 20,
    QuotaCurValueChanged = 21,
    QuotaPeriodChanged = 22,
    QuotaPeriodReset = 23,
    QuotaPercentageCrossed = 24,
    QuotaLimitReport = 32,
    QuotaLimitReportApiKey = 66,
    QuotaLimitReportNode = 67,
    Park = 25,
    Unpark = 26,
    Ban = 27,
    Unban = 28,
    Eject = 29,
    AccountLevelChanged = 30,
    PrivilegeLevelChanged = 31
  }
  export enum eTimelineDescriptorsColumns {
    None = 0,
    Timestamp = 1,
    UserKey = 2,
    Type = 3,
    Operation = 4,
    Message = 5,
    Info = 6
  }
  export enum eTimelineDescriptorType {
    Unknown = 0,
    Accounts = 1,
    ApiKeys = 2,
    BinaryResource = 3,
    Graphs = 4,
    Groups = 5,
    Nodes = 6,
    Things = 7,
    Quota = 8,
    User = 9
  }
  export const enum eUserConstantRequest {
    None = 0,
    Add = 1,
    Remove = 2,
    Update = 3,
    Get = 4
  }
  export const enum eUserMessageType {
    Info = 0,
    Warning = 1,
    Error = 2,
    Exception = 3
  }
  export const enum EventMsgType {
    Connection = 0,
    Notifications = 1,
    AuthKey = 2,
    BlockAction = 3,
    UserTrace = 4,
    LiveExecutionCtrl = 5,
    LiveExecutionBlockEvent = 6,
    LiveExecutionPortEvent = 7,
    ThingNameUpdate = 8,
    ThingShared = 9,
    ThingUnshared = 10,
    SampleGraphsRemoved = 11,
    PortEventMsg = 12,
    IncidentReport = 13,
    UserGraphException = 14,
    ThingSharePending = 15,
    LogoutUser = 16,
    UpdateUser = 17
  }
  export const enum eWarlockRequestType {
    None = 0,
    Read = 1,
    Write = 2,
    View = 3,
    Add = 4,
    Edit = 5,
    Delete = 6
  }
  export const enum eWSMsgId {
    None = 0,
    Pairing = 1,
    Api = 2,
    Warlock = 3
  }
  export const enum NodeUpdateAction {
    None = 0,
    Name = 1,
    Permissions = 2
  }
  export const enum NotificationDescriptorOperationType {
    UnDeployAfterThingRemove = 0,
    SharedThing = 1,
    UnsharedThing = 2,
    RemovedSampleGraphs = 3,
    DeployFailure = 4,
    UnDeployAfterAccountRemove = 5,
    QuotaLimitCrossed = 6,
    QuotaPercentageCrossed = 7,
    QuotaLimitUncrossed = 8,
    UnDeployAfterGroupRemove = 9,
    SharedGraph = 10,
    PendingReqExpired = 11,
    LoraEvent = 12,
    LoraThingUpdate = 13,
    ScheduleRemoval = 14,
    SigfoxEvent = 15,
    BlocksWarning = 16,
    DeploySuccess = 17
  }
  export const enum NotificationDescriptorType {
    Accounts = 0,
    Graphs = 1,
    Nodes = 2,
    Things = 3,
    ThingType = 4,
    SampleGraphs = 5,
    UserGraphException = 6,
    Quota = 7,
    Schedules = 8
  }
  export const enum NotificationPlacement {
    Notification = 1,
    Toast = 2
  }
  export const enum ResultType {
    Info = 0,
    Warning = 1,
    Error = 2
  }
  export const enum RouteRequest {
    Default = 0,
    LoadGraph = 1,
    LocateBlock = 2
  }
  export const enum ThingAction {
    None = 0,
    Hide = 1,
    UnHide = 2,
    Delete = 3
  }
  export const enum UpdateInfo {
    None = 0,
    Name = 1,
    Config = 2,
    Tags = 4,
    State = 8,
    Icon = 16,
    Type = 32,
    Hierarchy = 36,
    All = 64
  }
  export const enum UserPenaltyAction {
    None = 0,
    Ban = 1,
    UnBan = 2
  }
  export interface AccountDescriptorGet extends Warlock.WarlockApiMsg {
    request?: Warlock.AccountDescriptorGetReq;
  }
  export interface AccountDescriptorGetReq {
  }
  export interface AccountDescriptorGetRsp extends Warlock.GenericRsp {
    Account?: Warlock.UserDescriptor;
    ConnectedAccounts?: Warlock.UserDescriptor[];
  }
  export interface AccountInfoTimelineInfo extends Warlock.TimelineInfo {
    Type?: string;
  }
  export interface ActiveNodeDescriptor {
    ConnectionTimestamp?: Date;
    IpsInfo?: { [key: string]: Plegma.NodeLinkIpInfo };
    NodeKey?: Plegma.NodeKey;
    Status?: Warlock.eNodeStatus;
    TransientInfo?: { [key: string]: string };
  }
  export interface AddConfiguredRestService extends Warlock.WarlockApiMsg {
    Descriptor?: Warlock.ConfiguredRestServiceDescriptor;
  }
  export interface AddNewLinkedUserReq extends Warlock.WarlockApiMsg {
    linkedUserDescriptor?: Warlock.LinkedUserDescriptor;
  }
  export interface AddNotificationReq extends Warlock.WarlockApiMsg {
    Notificationdescriptor?: Warlock.NotificationDescriptor;
  }
  export interface AddPortRule extends Warlock.WarlockApiMsg {
    Clear?: boolean;
    PortKey?: Plegma.PortKey;
    Rule?: Warlock.PortRule;
  }
  export interface AddResourceDescriptorRequest extends Warlock.WarlockApiMsg {
    brdKey?: Plegma.BinaryResourceDescriptorKey;
    gKey?: Plegma.GraphDescriptorKey;
  }
  export interface AddRestServiceReq extends Warlock.WarlockApiMsg {
    desc?: Warlock.RestServiceDescriptor;
    updateExisting?: boolean;
  }
  export interface AddSocialAccount extends Warlock.WarlockApiMsg {
    desctype?: any;
    socialdesc?: any;
  }
  export interface AddThingIntoGroupsReq extends Warlock.WarlockApiMsg {
    groupKeys?: Plegma.GroupKey[];
    thingKey?: Plegma.ThingKey;
  }
  export interface AddThingReq extends Warlock.WarlockApiMsg {
    thingDescriptor?: Warlock.ThingDescriptor;
  }
  export interface AddThingsIntoGroupReq extends Warlock.WarlockApiMsg {
    groupKey?: Plegma.GroupKey;
    thingKeys?: Plegma.ThingKey[];
  }
  export interface AddUserSchedule extends Warlock.WarlockApiMsg {
    schedDesc?: Warlock.ScheduleDescriptor;
  }
  export interface ApiKeyDescriptor {
    BytesIO?: Warlock.QuotaDescriptor;
    CreatedTimestamp?: string;
    EventsIO?: Warlock.QuotaDescriptor;
    IsEnabled?: boolean;
    LastUsed?: string;
    LinkedKey?: string;
    Name?: string;
    TimesUsed?: number;
    Type?: Warlock.eApiKeyType;
    UserApiKey?: Plegma.UserApiKey;
  }
  export interface ApiKeyInfoTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
    Type?: Warlock.eApiKeyType;
  }
  export interface ApiKeyRsp extends Warlock.GenericRsp {
    ApiKeys?: Warlock.ApiKeyDescriptor[];
  }
  export interface ApplicationDomainAdd extends Warlock.WarlockApiMsg {
    request?: Warlock.ApplicationDomainAddReq;
  }
  export interface ApplicationDomainAddOwner extends Warlock.WarlockApiMsg {
    request?: Warlock.HandleApplicationDomainAddOwnerReq;
  }
  export interface ApplicationDomainAddReq {
    AppDomainID?: string;
    Description?: string;
  }
  export interface ApplicationDomainAddRsp extends Warlock.GenericRsp {
  }
  export interface ApplicationDomainDelete extends Warlock.WarlockApiMsg {
    request?: Warlock.ApplicationDomainDeleteReq;
  }
  export interface ApplicationDomainDeleteReq {
    AppDomainID?: string;
  }
  export interface ApplicationDomainDeleteRsp extends Warlock.GenericRsp {
  }
  export interface ApplicationDomainDescriptor {
    AppDomainID?: string;
    Description?: string;
    IsDefault?: boolean;
    Rights?: Warlock.ApplicationDomainUserRight[];
    Tld?: string;
  }
  export interface ApplicationDomainGet extends Warlock.WarlockApiMsg {
    request?: Warlock.ApplicationDomainGetReq;
  }
  export interface ApplicationDomainGetReq {
    AppDomainIDs?: string[];
  }
  export interface ApplicationDomainGetRsp extends Warlock.GenericRsp {
    AppDomains?: Warlock.ApplicationDomainDescriptor[];
  }
  export interface ApplicationDomainRemoveOwner extends Warlock.WarlockApiMsg {
    request?: Warlock.HandleApplicationDomainRemoveOwnerReq;
  }
  export interface ApplicationDomainSetDefault extends Warlock.WarlockApiMsg {
    request?: Warlock.ApplicationDomainSetDefaultReq;
  }
  export interface ApplicationDomainSetDefaultReq {
    AppDomainID?: string;
    RemoveDefault?: boolean;
  }
  export interface ApplicationDomainSetDefaultRsp extends Warlock.GenericRsp {
  }
  export interface ApplicationDomainUser {
    Email?: string;
    Pending?: boolean;
    Rights?: Warlock.ApplicationDomainUserRight[];
  }
  export interface ApplicationDomainUserRight {
    Tld?: string;
    Email?: string;
    AppDomainID?: string;
    EntityKey?: string;
    EntityType?: Warlock.eEntityType;
    Family?: Warlock.eARFamily;
    Layer?: Warlock.eARLayer;
    Level?: Warlock.eARLevel;
  }
  export interface AssetDescriptor extends Warlock.IAsset {
    EntityName?: string;
  }
  export interface AssignSipAccount extends Warlock.WarlockApiMsg {
  }
  export interface BanUnBanUserReq extends Warlock.WarlockApiMsg {
    penaltyAction?: Warlock.UserPenaltyAction;
    targetUserKey?: Plegma.UserKey;
  }
  export interface BinaryResourceDescriptorHelper {
  }
  export interface BinaryResourceDescriptorTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
  }
  export interface BinaryResourceDescRsp extends Warlock.GenericRsp {
    Descriptors?: Plegma.BinaryResourceDescriptor[];
  }
  export interface BlockActionReq {
    BlockId?: number;
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    Message?: string;
  }
  export interface BlockDescriptorInfo {
    Entity?: Warlock.eBlockEntity;
    Key?: string;
    Type?: string;
  }
  export interface BlockDescriptorReq extends Warlock.BlockDescriptorInfo {
    OnlyDynamicFields?: boolean;
  }
  export interface BlockInfo {
    BlockKey?: string;
    GraphName?: string;
    ImageUrl?: string;
    Name?: string;
    Type?: string;
  }
  export interface BlockPresenceReq extends Warlock.BlockDescriptorInfo {
    OnlyInDeployed?: boolean;
  }
  export interface BookmarkableLoadRoute extends Warlock.GenericRsp {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
  }
  export interface BRDRemoveReq extends Warlock.WarlockApiMsg {
    BinaryresourcedescriptorKey?: Plegma.BinaryResourceDescriptorKey;
  }
  export interface BRDUpdateReq extends Warlock.WarlockApiMsg {
    action?: Warlock.eBRDUpdateAction;
    brd?: Plegma.BinaryResourceDescriptor;
  }
  export interface BRDUploadReq extends Warlock.WarlockApiMsg {
    Binaryresourcedescriptor?: Plegma.BinaryResourceDescriptor;
  }
  export interface BundlesAdd extends Warlock.WarlockApiMsg {
    request?: Warlock.BundlesAddReq;
  }
  export interface BundlesAddReq {
  }
  export interface BundlesAddRsp extends Warlock.GenericRsp {
  }
  export interface BundlesDelete extends Warlock.WarlockApiMsg {
    request?: Warlock.BundlesDeleteReq;
  }
  export interface BundlesDeleteReq {
  }
  export interface BundlesDeleteRsp extends Warlock.GenericRsp {
  }
  export interface BundlesUpdate extends Warlock.WarlockApiMsg {
    request?: Warlock.BundlesUpdateReq;
  }
  export interface BundlesUpdateReq {
  }
  export interface BundlesUpdateRsp extends Warlock.GenericRsp {
  }
  export interface ChangeAccountLevel extends Warlock.WarlockApiMsg {
    accountLevel?: number;
    email?: string;
  }
  export interface ChangeGraphThrottlingLevelReq extends Warlock.WarlockApiMsg {
    key?: string;
    level?: number;
  }
  export interface ChangePrivilegeLevel extends Warlock.WarlockApiMsg {
    email?: string;
    privilege?: Warlock.ePrivilegeLevel;
  }
  export interface ChangeSmtpPasswordRequest extends Warlock.WarlockApiMsg {
    pwd?: string;
  }
  export interface ClearQuotaFlags extends Warlock.WarlockApiMsg {
    flagsToClear?: Warlock.eQuotaFlags;
    targetNkey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface ClearRestServicesReq extends Warlock.WarlockApiMsg {
  }
  export interface ConfiguredRestServiceDescriptor {
    Configuration?: { [key: string]: string };
    IconUri?: string;
    LastTokenUpdate?: Date;
    Name?: string;
    ServiceKey?: string;
  }
  export interface ConfigureUserMetadataReq extends Warlock.WarlockApiMsg {
    avataruri?: string;
    dt?: Date;
    email?: string;
    firstname?: string;
    lastname?: string;
    locale?: string;
    name?: string;
    uname?: string;
  }
  export interface ConfigureUserTimezoneReq extends Warlock.WarlockApiMsg {
    email?: string;
    TimezoneId?: string;
  }
  export interface ConstantDescriptor {
    InfoJson?: string;
    Name?: string;
    Type?: Warlock.eConstantType;
    Value?: string;
  }
  export interface ConstantDescriptorHelper {
  }
  export interface CreateApiKeyReqForOAuth extends Warlock.WarlockApiMsg {
    clientId?: string;
    redirectUrl?: string;
    scopes?: string;
  }
  export interface CreateGmailAccountReq extends Warlock.WarlockApiMsg {
    jsongmail?: string;
  }
  export interface CreateNewGroup extends Warlock.WarlockApiMsg {
    autoUpdate?: boolean;
    hierarchy?: string;
    icon?: string;
    name?: string;
    tags?: string[];
    things?: Warlock.ThingDescriptor[];
    type?: string;
  }
  export interface CreateNotificationUserReq extends Warlock.WarlockApiMsg {
    notificationUser?: Warlock.NotificationUserDescriptor;
    overwriteEmail?: string;
  }
  export interface CreateSnapshotReq extends Warlock.WarlockApiMsg {
    PortKeysStr?: string[];
  }
  export interface CreateUserApiKeyInfo extends Warlock.WarlockApiMsg {
    key?: string;
    name?: string;
    type?: Warlock.eApiKeyType;
  }
  export interface CreateValueTriggerGraphEvent extends Warlock.WarlockApiMsg {
    Email?: string;
    PortKey?: Plegma.PortKey;
    Rule?: Warlock.PortRule;
  }
  export interface CreateWatchdogGraphEvent extends Warlock.WarlockApiMsg {
    Email?: string;
    PortKey?: Plegma.PortKey;
    Rule?: Warlock.PortRule;
    Timer?: any;
  }
  export interface DashboardGraphsResponse extends Warlock.GenericRsp {
    DeployedGraphs?: number;
    SavedGraphs?: number;
  }
  export interface DatabaseActionReq extends Warlock.WarlockApiMsg {
    Action?: Warlock.eDatabaseInfoReqType;
    DbName?: string;
    DbNameKey?: string;
    DbUsername?: string;
    DbUsernameKey?: string;
    HostedByYodiwo?: boolean;
    Password?: string;
    Port?: number;
    Privileges?: string[];
    Server?: string;
    targetUserKey?: Plegma.UserKey;
    Type?: string;
  }
  export interface DatabaseActionRsp extends Warlock.GenericRsp {
    BlockInfos?: Warlock.DatabaseBlockInfo[];
  }
  export interface DatabaseBlockInfo {
    BlockName?: string;
    BlockUID?: number;
    ConnectionString?: string;
    DbName?: string;
    DbNameKey?: string;
    DbUsername?: string;
    DbUsernameKey?: string;
    GraphDescriptorKey?: string;
    GraphFullPath?: string;
    HostedByYodiwo?: boolean;
    IsDeployed?: boolean;
  }
  export interface DatabaseInfo {
    Type?: string;
  }
  export interface DatabaseInfoDescriptor extends Warlock.DatabaseInfoDescriptorCommon {
    LinkedUsersCnt?: number;
  }
  export interface DatabaseInfoDescriptorCommon {
    ConnectionString?: string;
    DbName?: string;
    DbNameKey?: string;
    DbUsername?: string;
    DbUsernameKey?: string;
    HostedByYodiwo?: boolean;
    Privileges?: string[];
    Type?: string;
  }
  export interface DatabaseMultiActionReq extends Warlock.WarlockApiMsg {
    Requests?: Warlock.DatabaseActionReq[];
  }
  export interface DatabaseMultiActionRsp extends Warlock.GenericRsp {
    Responses?: { [key: string]: Warlock.DatabaseActionRsp };
  }
  export interface DatabaseUserInfoDescriptor extends Warlock.DatabaseInfoDescriptorCommon {
    LinkedSchemasCnt?: number;
  }
  export interface DeleteDescriptorRequest extends Warlock.WarlockApiMsg {
    brdKey?: Plegma.BinaryResourceDescriptorKey;
    gKey?: Plegma.GraphDescriptorKey;
  }
  export interface DeleteNotificationUserReq extends Warlock.WarlockApiMsg {
    email?: string;
  }
  export interface DeleteThingGroupReq extends Warlock.WarlockApiMsg {
    Groupkey?: Plegma.GroupKey;
    Thingkey?: Plegma.ThingKey;
  }
  export interface DeleteUploadedFileReq extends Warlock.WarlockApiMsg {
    BrdKey?: Plegma.BinaryResourceDescriptorKey;
  }
  export interface DeleteUserReq extends Warlock.WarlockApiMsg {
    email?: string;
  }
  export interface DeployedGraphRevRsp extends Warlock.GenericRsp {
    DeployedRev?: number;
    LatestRev?: number;
  }
  export interface DeployFailureNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    ErrorMsg?: string;
  }
  export interface DeployResponse extends Warlock.GenericRsp {
    GraphDescriptorKey?: string;
    ValidationResults?: { [key: string]: Warlock.ValidationResDescriptor[] };
  }
  export interface DocumentationWrlkDescriptor {
    Content?: string;
    ContentType?: Warlock.eDocumentationContentType;
    Name?: string;
  }
  export interface DomainUserAdd extends Warlock.WarlockApiMsg {
    request?: Warlock.DomainUserAddReq;
  }
  export interface DomainUserAddReq {
    AppDomainID?: string;
    Email?: string;
  }
  export interface DomainUserAddRsp extends Warlock.GenericRsp {
  }
  export interface DomainUserChangeRights extends Warlock.WarlockApiMsg {
    request?: Warlock.DomainUserChangeRightsReq;
  }
  export interface DomainUserChangeRightsReq {
    Email?: string;
    Rights?: Warlock.ApplicationDomainUserRight[];
  }
  export interface DomainUserChangeRightsRsp extends Warlock.GenericRsp {
  }
  export interface DomainUserDescriptor {
    AppDomainIds?: string[];
    Email?: string;
    Info?: Warlock.DomainUserInfo;
    Pending?: boolean;
    Rights?: Warlock.ApplicationDomainUserRight[];
    Tld?: string;
  }
  export interface DomainUserGet extends Warlock.WarlockApiMsg {
    request?: Warlock.DomainUserGetReq;
  }
  export interface DomainUserGetReq {
    AppDomainID?: string;
    Email?: string;
    ParseRights?: boolean;
  }
  export interface DomainUserGetRsp extends Warlock.GenericRsp {
    Users?: Warlock.DomainUserDescriptor[];
  }
  export interface DomainUserInfo {
    AvatarUri?: string;
    Company?: string;
    Country?: string;
    Email?: string;
    FirstName?: string;
    JobTitle?: string;
    LastName?: string;
    TelNo?: string;
  }
  export interface DomainUserRemove extends Warlock.WarlockApiMsg {
    request?: Warlock.DomainUserRemoveReq;
  }
  export interface DomainUserRemoveReq {
    Email?: string;
  }
  export interface DomainUserRemoveRsp extends Warlock.GenericRsp {
  }
  export interface EjectUserReq extends Warlock.WarlockApiMsg {
    key?: string;
  }
  export interface EmailRequest extends Warlock.WarlockApiMsg {
    Body?: string;
    Subject?: string;
  }
  export interface EnableDisableApiKey extends Warlock.WarlockApiMsg {
    action?: string;
    apiKey?: string;
  }
  export interface EnumerateSaveandDeployedGraphsReq extends Warlock.WarlockApiMsg {
  }
  export interface EvGraphsUndeployedDueToGroupRemoval extends Yodiwo.API.EvCommon {
    UserKey?: Plegma.UserKey;
  }
  export interface EvGraphsUndeployedDueToThingRemoval extends Yodiwo.API.EvCommon {
    UserKey?: Plegma.UserKey;
  }
  export interface EvNewBackendNotification extends Warlock.EvNewNotification {
  }
  export interface EvNewFrontendNotification extends Warlock.EvNewNotification {
  }
  export interface EvNewNotification extends Yodiwo.API.EvCommon {
    DestinationUserKey?: Plegma.UserKey;
    NotificationDescriptor?: Warlock.NotificationDescriptor;
  }
  export interface EvSampleGraphsRemoved extends Yodiwo.API.EvCommon {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey[];
    GraphFriendlyName?: string[];
    NodeType?: string;
  }
  export interface EvThingCommon extends Yodiwo.API.EvCommon {
    Name?: string;
    ThingKey?: Plegma.ThingKey;
  }
  export interface EvThingConfigUpdated extends Warlock.EvThingCommon {
    OldConfig?: Plegma.ConfigParameter[];
  }
  export interface EvThingNameUpdated extends Warlock.EvThingCommon {
  }
  export interface EvThingShared extends Warlock.EvThingCommon {
    DestinationUserKey?: Plegma.UserKey;
    IsRead?: boolean;
    RequesterEmail?: string;
  }
  export interface EvThingSharePending extends Warlock.EvThingShared {
    IsPending?: boolean;
    IsQuestion?: boolean;
    PendingToken?: string;
  }
  export interface EvThingUnshared extends Warlock.EvThingCommon {
    DestinationUserKey?: Plegma.UserKey;
    RequesterEmail?: string;
    RequesterUserKey?: Plegma.UserKey;
  }
  export interface ExternalServiceBlockAddOrUpdate extends Warlock.WarlockApiMsg {
    BlockInfoJson?: string;
    mqttpassword?: string;
  }
  export interface ExternalServiceBlockDelete extends Warlock.WarlockApiMsg {
    BlockKey?: string;
  }
  export interface ExternalServiceBlockKeyListing extends Warlock.WarlockApiMsg {
  }
  export interface ExternalServiceBlockListingResp extends Plegma.GenericRsp {
    Keys?: string[];
  }
  export interface FileDescriptor {
    accessToken?: string;
    FileDesc?: string;
    FileLength?: number;
    FileName?: string;
    guid?: string;
    HasBeenUploaded?: boolean;
    udesc?: Warlock.uploadCallback;
  }
  export interface FileMetadata {
    AutoDelete?: boolean;
    DueDate?: Date;
    Guid?: string;
    LastFetched?: Date;
    MaxFetchTimes?: number;
    TimesFetched?: number;
  }
  export interface GenerateGraphFromSwaggerAPI extends Warlock.WarlockApiMsg {
    isUrl?: boolean;
    jsonOrUrl?: string;
    Name?: string;
    Path?: string;
  }
  export interface GetAllApiKeysReq extends Warlock.WarlockApiMsg {
    userApiKeys?: Plegma.UserApiKey[];
  }
  export interface GetAllConfiguredRestServicesReq extends Warlock.WarlockApiMsg {
  }
  export interface GetAllImagesReq extends Warlock.WarlockApiMsg {
  }
  export interface GetAllNotificationsReq extends Warlock.WarlockApiMsg {
  }
  export interface GetAllPortKeys extends Warlock.WarlockApiMsg {
    AllThingKeysStr?: string[];
  }
  export interface GetAllPorts extends Warlock.WarlockApiMsg {
    AllThingKeysStr?: string[];
  }
  export interface GetAllRestServicesReq extends Warlock.WarlockApiMsg {
  }
  export interface GetAllUserDescriptorsReq extends Warlock.WarlockApiMsg {
  }
  export interface GetAssets extends Warlock.WarlockApiMsg {
    request?: Warlock.GetAssetsReq;
  }
  export interface GetAssetsReq extends Warlock.IAsset {
    FetchAll?: boolean;
    OrphansOnly?: boolean;
  }
  export interface GetAssetsRsp extends Warlock.GenericRsp {
    Assets?: Warlock.AssetDescriptor[];
  }
  export interface GetBinaryResourceDesciptorsRequest extends Warlock.WarlockApiMsg {
    BinaryresourcedescriptorKey?: Plegma.BinaryResourceDescriptorKey;
  }
  export interface GetBlockDescriptorReq extends Warlock.WarlockApiMsg {
    bdReq?: Warlock.BlockDescriptorReq;
  }
  export interface GetBlockInfoReq extends Warlock.WarlockApiMsg {
    blockKey?: Plegma.BlockKey;
  }
  export interface GetBlockPresenceInGraphsReq extends Warlock.WarlockApiMsg {
    presenceReq?: Warlock.BlockPresenceReq;
  }
  export interface GetBundles extends Warlock.WarlockApiMsg {
    request?: Warlock.GetBundlesReq;
  }
  export interface GetBundlesReq {
  }
  export interface GetBundlesRsp extends Warlock.GenericRsp {
  }
  export interface GetDatabaseInstancesReq extends Warlock.WarlockApiMsg {
    DbUsername?: Plegma.DbKey;
    targetUserKey?: Plegma.UserKey;
  }
  export interface GetDatabasesInfoReq extends Warlock.WarlockApiMsg {
    DbNames?: Plegma.DbKey[];
    targetUserKey?: Plegma.UserKey;
  }
  export interface GetDatabasesUsersInfoReq extends Warlock.WarlockApiMsg {
    targetUserKey?: Plegma.UserKey;
    Usernames?: Plegma.DbKey[];
  }
  export interface GetDatabaseUsersInstancesReq extends Warlock.WarlockApiMsg {
    DbName?: Plegma.DbKey;
    targetUserKey?: Plegma.UserKey;
  }
  export interface GetFirstAuthUrlReq extends Warlock.WarlockApiMsg {
    BlockName?: string;
    ServiceKey?: string;
  }
  export interface GetHttpHooksReq {
    UserKey?: Plegma.UserKey;
  }
  export interface GetHttpHooksRsp extends Warlock.GenericRsp {
    InHooks?: { [key: string]: Warlock.IHttpHook[] };
  }
  export interface GetImageReq extends Warlock.WarlockApiMsg {
    brdkey?: Plegma.BinaryResourceDescriptorKey;
  }
  export interface GetLinkedUsersReq extends Warlock.WarlockApiMsg {
    linkedUserEmail?: string;
  }
  export interface GetMacroBlockIOsInfoReq extends Warlock.WarlockApiMsg {
    gdKey?: Plegma.GraphDescriptorKey;
    originKey?: Plegma.GraphDescriptorKey;
  }
  export interface GetMetadataReq {
    Guids?: string[];
  }
  export interface GetMetadataRsp extends Warlock.GenericRsp {
    Files?: Warlock.FileMetadata[];
  }
  export interface GetNewGroupsForThingReq extends Warlock.WarlockApiMsg {
    thingKey?: Plegma.ThingKey;
  }
  export interface GetNewThingsForGroupReq extends Warlock.WarlockApiMsg {
    groupKey?: Plegma.GroupKey;
  }
  export interface GetNodeDescriptorsReq extends Warlock.WarlockApiMsg {
    NodeKeys?: Plegma.NodeKey[];
    NodeName?: string;
    NodeType?: Plegma.eNodeType;
    parseAllThings?: boolean;
    query?: any;
  }
  export interface GetNotificationsRsp extends Warlock.GenericRsp {
    NotificationDescriptors?: Warlock.NotificationDescriptor[];
  }
  export interface GetNotificationUsersReq extends Warlock.WarlockApiMsg {
    email?: string;
  }
  export interface GetPortReq extends Warlock.WarlockApiMsg {
    PortKey?: Plegma.PortKey;
  }
  export interface GetRestServiceDescriptorFromSwaggerAPIReq extends Warlock.WarlockApiMsg {
    isUrl?: boolean;
    jsonOrUrl?: string;
  }
  export interface GetRichTextDescriptorReq extends Warlock.WarlockApiMsg {
    keys?: Plegma.GraphDescriptorKey[];
  }
  export interface GetSharedThingsReq extends Warlock.WarlockApiMsg {
    ThingKeys?: Plegma.ThingKey[];
  }
  export interface GetSharedThingsRsp extends Warlock.GenericRsp {
    SharedThings?: Warlock.ThingShareInfoDescriptor[];
  }
  export interface GetSocialAccountsReq extends Warlock.WarlockApiMsg {
  }
  export interface GetThingGraphsInfoReq extends Warlock.WarlockApiMsg {
    ThingKey?: string;
  }
  export interface GetThingGroupReq extends Warlock.WarlockApiMsg {
    FillThings?: boolean;
    GroupKey?: Plegma.GroupKey;
  }
  export interface GetThingKeyReq extends Warlock.WarlockApiMsg {
    IsVirtual?: boolean;
    NodeKey?: Plegma.NodeKey;
  }
  export interface GetThingKeyRsp extends Warlock.GenericRsp {
    IsLoRaThing?: boolean;
    ThingKey?: Plegma.ThingKey;
  }
  export interface GetThingsReq extends Warlock.WarlockApiMsg {
    key?: string;
    Thingkeys?: Plegma.ThingKey[];
    thingsQuery?: any;
  }
  export interface GetThingsRsp extends Warlock.GenericRsp {
    FilteredThings?: Warlock.ThingDescriptor[];
    FilteredThingsCnt?: number;
    ThingsCnt?: number;
    ThingsPerNode?: { [key: string]: Warlock.ThingDescriptor[] };
  }
  export interface GetThingTypesReq extends Warlock.WarlockApiMsg {
    SearchForYodiwoTypes?: boolean;
  }
  export interface GetThingTypesRsp extends Warlock.GenericRsp {
    ThingTypeDescriptors?: Warlock.ThingTypeDescriptor[];
  }
  export interface GetTimelineDescriptorsReq extends Warlock.WarlockApiMsg {
    FromTS?: Date;
    Operation?: Warlock.eTimelineDescriptorOperationType;
    Query?: Warlock.TimelineDescriptorsQuery;
    TargetUserKey?: Plegma.UserKey;
    ToTS?: Date;
    Type?: Warlock.eTimelineDescriptorType;
  }
  export interface GetToolboxModelViewReq extends Warlock.WarlockApiMsg {
    ignoreNodes?: boolean;
    refreshAll?: boolean;
    searchText?: string;
    useCache?: boolean;
  }
  export interface GetUserDescriptorReq extends Warlock.WarlockApiMsg {
  }
  export interface GetUserIdReq extends Warlock.WarlockApiMsg {
    email?: string;
  }
  export interface GetUserInfoRsp extends Warlock.WarlockApiMsg {
    UserInfo?: { [key: string]: Warlock.UserInfo };
  }
  export interface GetUserMessagesReq extends Warlock.WarlockApiMsg {
    Page?: number;
    PageSize?: number;
  }
  export interface GetUserQuotaReq extends Warlock.WarlockApiMsg {
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
  }
  export interface GetUserSchedule extends Warlock.WarlockApiMsg {
    skey?: Plegma.ScheduleKey;
  }
  export interface GetUserTokensReq extends Warlock.WarlockApiMsg {
    Emails?: string[];
    Names?: string[];
  }
  export interface GetUserTokensRsp extends Warlock.GenericRsp {
    Tokens?: { [key: string]: string };
  }
  export interface GrafanaSnapshotCreateResponse extends Warlock.GenericRsp {
    DeleteKey?: string;
    DeleteUrl?: string;
    Key?: string;
    Url?: string;
  }
  export interface GraphActionReq extends Warlock.WarlockApiMsg {
    ActionType?: Warlock.eGraphActionType;
    GraphDescriptorKey?: string;
    JsonData?: string;
    TargetUserEmail?: string;
  }
  export interface GraphActionRsp extends Warlock.GenericRsp {
    GraphDescriptorKey?: string;
    isPending?: boolean;
    JsonData?: string;
  }
  export interface GraphActionsReq extends Warlock.WarlockApiMsg {
    Actions?: Warlock.GraphActionReq[];
  }
  export interface GraphActionUpdateReq {
    Name?: string;
    Path?: string;
  }
  export interface GraphDescriptorAndGroupNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    FriendlyName?: string;
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    GroupKey?: Plegma.GroupKey;
    GroupName?: string;
    Path?: string;
  }
  export interface GraphDescriptorAndThingNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    FriendlyName?: string;
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    Path?: string;
    ThingKey?: Plegma.ThingKey;
    ThingName?: string;
  }
  export interface GraphDescriptorNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    FriendlyName?: string;
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    Path?: string;
  }
  export interface GraphDescriptorTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
    Path?: string;
  }
  export interface GraphSharedNotificationInfo extends Warlock.GraphDescriptorNotificationInfo {
    RequesterEmail?: string;
  }
  export interface GraphWrlkDescriptor extends Plegma.DbDocument<Warlock.GraphWrlkDescriptor> {
    AvailableGraphs?: Warlock.RevisionInfo[];
    Clones?: number;
    ContainsAnyMacroBlocks?: boolean;
    CreatedTimestamp?: string;
    DeployedRevision?: number;
    FriendlyName?: string;
    GraphDescriptorBaseKey?: string;
    HasRichTextFields?: boolean;
    IsDeployed?: boolean;
    IsStateful?: boolean;
    LatestRevision?: number;
    Options?: Plegma.GraphOptions;
    Path?: string;
    ThrottlingRequestLimit?: number;
  }
  export interface GroupDescriptor {
    AutoUpdate?: boolean;
    GroupKey?: Plegma.GroupKey;
    Hierarchy?: string;
    Icon?: string;
    Name?: string;
    Tags?: string[];
    Things?: Warlock.ThingDescriptor[];
    ThingsCount?: number;
    Type?: string;
  }
  export interface GroupInfoTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
  }
  export interface GroupsRsp extends Warlock.GenericRsp {
    GroupDescriptors?: Warlock.GroupDescriptor[];
  }
  export interface HandleApplicationDomainAddOwnerReq {
    AppDomainID?: string;
    Email?: string;
  }
  export interface HandleApplicationDomainAddOwnerRsp extends Warlock.GenericRsp {
  }
  export interface HandleApplicationDomainRemoveOwnerReq {
    AppDomainID?: string;
    Email?: string;
  }
  export interface HandleApplicationDomainRemoveOwnerRsp extends Warlock.GenericRsp {
  }
  export interface IAsset {
    BundleKey?: string;
    EntityKey?: string;
    EntityType?: Warlock.eEntityType;
  }
  export interface IHttpHook {
    ApiKey?: Plegma.UserApiKey;
    BlockKey?: Plegma.BlockKey;
    GroupId?: number;
    Method?: string;
    SubPath?: string;
    SyncType?: string;
    Timeout?: number;
    Workflow?: string;
  }
  export interface LinkApiKeytoNode extends Warlock.WarlockApiMsg {
    nk?: Plegma.NodeKey;
    userapikey?: Plegma.UserApiKey;
  }
  export interface LinkedUserDescriptor {
    AvatarUri?: string;
    CreatedTimeStr?: string;
    Email?: string;
    IsPrimary?: boolean;
    LastLoginDateStr?: string;
    Name?: string;
    PrivilegeLevelStr?: string;
    SubUserKey?: Plegma.SubUserKey;
  }
  export interface LiveExecutionAddListeners extends Warlock.WarlockApiMsg {
    Blocklisteners?: Plegma.BlockKey[];
    GraphListeners?: Plegma.GraphDescriptorKey[];
    ListenerKey?: any;
    ListenerType?: Warlock.eLiveListenerType;
    PortListeners?: Plegma.PortKey[];
  }
  export interface LiveExecutionEvent extends Warlock.WarlockApiMsg {
    LiveExecutionEvType?: Warlock.eLiveExecutionEventType;
    LiveExecutionPortStates?: any;
    LiveExecutionSolve?: any;
    Session?: string;
  }
  export interface LiveExecutionRemoveListeners extends Warlock.WarlockApiMsg {
    Blocklisteners?: Plegma.BlockKey[];
    GraphListeners?: Plegma.GraphDescriptorKey[];
    ListenerKey?: any;
    ListenerType?: Warlock.eLiveListenerType;
    PortListeners?: Plegma.PortKey[];
  }
  export interface LiveKeysAddMsg extends Warlock.LiveKeysMsg {
  }
  export interface LiveKeysDelMsg extends Warlock.LiveKeysMsg {
  }
  export interface LiveKeysMsg extends Warlock.WarlockApiMsg {
    ApiKey?: string;
    LivePortKeys?: string[];
  }
  export interface LiveValue {
    BlockKey?: string;
    Extra?: string;
    Index?: number;
    IoName?: string;
    IsConnected?: boolean;
    IsDirty?: boolean;
    IsInput?: boolean;
    IsOutput?: boolean;
    IsPort?: boolean;
    IsTouched?: boolean;
    PortKey?: string;
    RevNum?: number;
    Timestamp?: number;
    Value?: any;
  }
  export interface LiveValuesMsg extends Warlock.WarlockApiMsg {
    LiveValues?: Warlock.LiveValue[];
  }
  export interface LoadFilesReq extends Warlock.WarlockApiMsg {
  }
  export interface LoadGraphByFriendlyName extends Warlock.WarlockApiMsg {
    name?: string;
    path?: string;
  }
  export interface LoadGraphsReq extends Warlock.WarlockApiMsg {
    baseKeys?: Plegma.GraphDescriptorBaseKey[];
  }
  export interface LoadGraphsResp extends Warlock.GenericRsp {
    FolderPaths?: string[];
    GraphDescriptors?: Warlock.GraphWrlkDescriptor[];
  }
  export interface MacroBlockIOInfo {
    ConnectedIndexStr?: string;
    ConnectedUID?: number;
    IndexStr?: string;
  }
  export interface MoveAssets extends Warlock.WarlockApiMsg {
    request?: Warlock.MoveAssetsReq;
  }
  export interface MoveAssetsReq {
    EntityKeys?: string[];
    EntityType?: Warlock.eEntityType;
    OrphanAssets?: Warlock.AssetDescriptor[];
    SourceBundleKey?: string;
    TargetBundleKey?: string;
  }
  export interface MoveAssetsRsp extends Warlock.GenericRsp {
  }
  export interface MultiGraphActionRsp extends Warlock.GenericRsp {
    Responses?: Warlock.GraphActionRsp[];
  }
  export interface MultipleThingActionReq extends Warlock.WarlockApiMsg {
    Action?: Warlock.ThingAction;
    ThingKeys?: Plegma.ThingKey[];
  }
  export interface MyHackingRsp extends Warlock.WarlockApiMsg {
    AppToken?: string;
    IsSuccess?: boolean;
    Key?: string;
  }
  export interface NodeCreateReq extends Warlock.WarlockApiMsg {
    AdditionalInfo?: { [key: string]: string };
    Capabilities?: Plegma.eNodeCapa;
    Flags?: Warlock.eNodeFlags;
    Name?: string;
    Permissions?: Warlock.eNodePermissions;
    Type?: Plegma.eNodeType;
  }
  export interface NodeCreateRsp extends Warlock.GenericRsp {
    Nodekey?: Plegma.NodeKey;
    Secret?: string;
  }
  export interface NodeDescriptor {
    ActiveInfo?: Warlock.ActiveNodeDescriptor;
    AdditionalInfo?: { [key: string]: string };
    BytesIO?: Warlock.QuotaDescriptor;
    Capabilities?: Plegma.eNodeCapa;
    CapabilitiesStr?: string;
    EventsIO?: Warlock.QuotaDescriptor;
    IgnoreQuota?: boolean;
    IsDisabled?: boolean;
    LinkedApiKeys?: { [key: string]: Plegma.UserApiKey };
    Name?: string;
    NodeKey?: Plegma.NodeKey;
    PairingTimestamp?: string;
    Permissions?: Warlock.eNodePermissions;
    PrimaryEmail?: string;
    SecretKey?: string;
    Status?: Warlock.eNodeStatus;
    SupportedApiRev?: number;
    Things?: Warlock.ThingDescriptor[];
    ThingsCount?: number;
    ThingsRevNum?: number;
    Type?: Plegma.eNodeType;
    TypeStr?: string;
    Uuid?: string;
  }
  export interface NodeDescriptorsRsp extends Warlock.GenericRsp {
    FilteredNodes?: number;
    NodeDescriptors?: Warlock.NodeDescriptor[];
    NodesCnt?: number;
  }
  export interface NodeDisableReq extends Warlock.WarlockApiMsg {
    nodekey?: Plegma.NodeKey;
  }
  export interface NodeEnableReq extends Warlock.WarlockApiMsg {
    nodekey?: Plegma.NodeKey;
  }
  export interface NodeInfoModelDescriptor {
    Name?: string;
    NodeId?: string;
    NodeKey?: string;
  }
  export interface NodeInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    Name?: string;
    NodeKey?: Plegma.NodeKey;
  }
  export interface NodeInfoTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
  }
  export interface NodeStatusRsp extends Warlock.GenericRsp {
    NodeStatus?: Warlock.eNodeStatus;
  }
  export interface NodeUpdateReq extends Warlock.WarlockApiMsg {
    Action?: Warlock.NodeUpdateAction;
    Name?: string;
    Nodekey?: Plegma.NodeKey;
    NodePermissions?: Warlock.eNodePermissions;
  }
  export interface NotificationDescriptor extends Plegma.DbDocument<Warlock.NotificationDescriptor> {
    Description?: string;
    HasRelatedObject?: boolean;
    IsModal?: boolean;
    IsPending?: boolean;
    IsRead?: boolean;
    NotificationDescriptorKey?: Warlock.NotificationDescriptorKey;
    NotificationDescriptorRelatedObject?: any;
    Operation?: Warlock.NotificationDescriptorOperationType;
    PendingToken?: string;
    Placement?: Warlock.NotificationPlacement;
    Severity?: Warlock.eSeverity;
    Timestamp?: Date;
    ToastrDesc?: Warlock.ToastrDescriptor;
    Type?: Warlock.NotificationDescriptorType;
  }
  export interface NotificationDescriptorKey {
    Id?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface NotificationDescriptorRelatedObject {
  }
  export interface NotificationMarkAllAsRead extends Warlock.WarlockApiMsg {
  }
  export interface NotificationMarkAsRead extends Warlock.WarlockApiMsg {
    key?: string;
  }
  export interface NotificationUserDescriptor {
    Email?: string;
    FirstName?: string;
    LastName?: string;
  }
  export interface OAuth {
    Clients?: { [key: string]: Warlock.OAuthClientInfo };
    Scopes?: string[];
  }
  export interface OAuthClientInfo {
    ClientId?: string;
    RedirectUrl?: string;
  }
  export interface OAuthGetTokenResponse extends Warlock.GenericRsp {
    RedirectUrl?: string;
    Token?: string;
  }
  export interface OAuthRestParameters {
    ConsumerKey?: string;
    ConsumerKeyName?: string;
    ConsumerSecret?: string;
    ConsumerSecretName?: string;
    TokenName?: string;
    TokenSecretName?: string;
  }
  export interface PackagesReq extends Warlock.WarlockApiMsg {
    pkgsToDisable?: string[];
    pkgsToEnable?: string[];
    targetUserKey?: Plegma.UserKey;
  }
  export interface ParkUserReq extends Warlock.WarlockApiMsg {
    email?: string;
  }
  export interface PortDescriptor {
    Color?: string;
    ConfFlags?: Plegma.ePortConf;
    Description?: string;
    Extra?: string;
    HasRules?: boolean;
    IoDirection?: string;
    IsInput?: boolean;
    IsOutput?: boolean;
    LastUpdatedTimestamp?: string;
    Name?: string;
    Port?: Plegma.Port;
    PortKey?: string;
    PortModelId?: string;
    PortType?: string;
    RevNum?: string;
    Rules?: Warlock.PortRule[];
    Semantics?: string;
    Size?: number;
    State?: string;
  }
  export interface PortInformation extends Warlock.PortDescriptor {
    Index?: string;
  }
  export interface PortRule {
    Classification?: string;
    Left?: any;
    LeftEqualInclusive?: boolean;
    Pattern?: string;
    Right?: any;
    RightEqualInclusive?: boolean;
  }
  export interface QuotaDescriptor {
    AlertPercentage?: number;
    IsInformational?: boolean;
    IsNonResettable?: boolean;
    IsOverLimit?: boolean;
    Limit?: number;
    NoAutoUpdates?: boolean;
    Overage?: number;
    Period?: any;
    QuotaCycleStartCurrent?: Date;
    QuotaCycleStartNext?: Date;
    QuotaCycleTimeLeft?: any;
    TotalNumForPeriod?: number;
  }
  export interface QuotaNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    AfterManualLimitLift?: boolean;
    AfterManualPeriodReset?: boolean;
    LimitCurrent?: number;
    Name?: string;
    Percentage?: number;
    Period?: any;
    TotalPeriodNumCurrent?: number;
  }
  export interface QuotaTimelineInfo extends Warlock.TimelineInfo {
    AfterManualLimitLift?: boolean;
    AfterManualPeriodReset?: boolean;
    LimitCurrent?: number;
    LimitOld?: number;
    ManualResetByUser?: boolean;
    Name?: string;
    Overage?: number;
    Percentage?: number;
    PeriodCurrent?: any;
    PeriodOld?: any;
    StartOfPeriod?: Date;
    TotalNumCurrent?: number;
    TotalNumForPeriodCurrent?: number;
    TotalNumForPeriodOld?: number;
    TotalNumOld?: number;
  }
  export interface RecoveredNodesModelView {
    nodesinfo?: Warlock.NodeInfoModelDescriptor[];
    uuid?: string;
  }
  export interface RegisterUserKeyReq extends Warlock.WarlockApiMsg {
    Userkeys?: Plegma.UserKey[];
  }
  export interface RegisterUserKeyRsp extends Warlock.GenericRsp {
    RspPerUkey?: { [key: string]: boolean };
  }
  export interface RemoveApiKeyReq extends Warlock.WarlockApiMsg {
    apiKey?: string;
  }
  export interface RemoveConfiguredRestServicesReq extends Warlock.WarlockApiMsg {
    Name?: string;
  }
  export interface RemoveLinkedUserReq extends Warlock.WarlockApiMsg {
    LinkedUserEmail?: string;
  }
  export interface RemoveRestServicesReq extends Warlock.WarlockApiMsg {
    ServiceName?: string;
  }
  export interface RemoveSocialAccountReq extends Warlock.WarlockApiMsg {
    Data?: string;
    Type?: string;
  }
  export interface RemoveUserSchedule extends Warlock.WarlockApiMsg {
    skey?: Plegma.ScheduleKey;
  }
  export interface RequestExternalGraphAction extends Warlock.WarlockApiMsg {
    blockMessage?: Warlock.BlockActionReq;
  }
  export interface RereadQuotaDataTablesReq extends Warlock.WarlockApiMsg {
  }
  export interface ResetQuotaPeriod extends Warlock.WarlockApiMsg {
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface RestApiYodiUpDescriptor extends Warlock.SingleFileResp {
    UserToken?: string;
    WasDeleted?: boolean;
  }
  export interface RestAuthReq extends Warlock.WarlockApiMsg {
    BlockName?: string;
    ServiceName?: string;
  }
  export interface RestFormattedConfigParam {
    ApplicableRouteTypes?: Warlock.eRestRouteTypes;
    Name?: string;
    Type?: Warlock.eRestParameterType;
    Value?: string;
  }
  export interface RestParameterDescriptor {
    DefaultValue?: any;
    Name?: string;
    Type?: Warlock.eRestParameterType;
  }
  export interface RestServiceDescriptor {
    BaseUrl?: string;
    BaseUrlRoot?: string;
    Icon?: string;
    InitDescriptor?: Warlock.RestServiceInitDescriptor;
    IsUserService?: boolean;
    Routes?: Warlock.RestServiceRoute[];
    ServiceName?: string;
  }
  export interface RestServiceInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    BlockName?: string;
    Icon?: string;
    JsonService?: string;
  }
  export interface RestServiceInitDescriptor {
    AuthType?: Warlock.eRestServiceAuthTypes;
    ConfigParams?: Warlock.RestFormattedConfigParam[];
    FirstAuth?: Warlock.RestServiceRoute;
    GetRequestToken?: Warlock.RestServiceRoute;
    OAuth1Names?: Warlock.OAuthRestParameters;
    RefreshToken?: Warlock.RestServiceRoute;
    SecondAuth?: Warlock.RestServiceRoute;
    StateToken?: string;
  }
  export interface RestServiceRoute {
    FriendlyName?: string;
    JsonBody?: boolean;
    Method?: Warlock.eRestServiceRouteMethod;
    Parameters?: Warlock.RestParameterDescriptor[];
    Path?: string;
    PlaceJsonBodyOnHeader?: string;
    RouteType?: Warlock.eRestRouteTypes;
  }
  export interface RestServiceStatics {
    BaseUrl?: string;
    HttpBasicAuthPassword?: string;
    HttpBasicAuthUsername?: string;
  }
  export interface RevisionInfo {
    GraphDescriptorKey?: string;
    IsExportedAsMacroBlock?: boolean;
    Revision?: number;
    UpdatedTimestamp?: string;
  }
  export interface RichTextDescriptor {
    BlockUid?: number;
    Code?: string;
    FieldId?: string;
    GraphDescriptorKey?: string;
    Language?: Warlock.eRichTextDescriptorLanguageDescriptor;
    Name?: string;
  }
  export interface SampleGraphDescriptorNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey[];
    GraphFriendlyName?: string[];
    NodeType?: string;
  }
  export interface SaveGraphOptionsReq {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    Options?: Plegma.GraphOptions;
  }
  export interface SaveGraphOptionsRsp {
    IsStateful?: boolean;
    Options?: Plegma.GraphOptions;
  }
  export interface ScanReq extends Warlock.WarlockApiMsg {
    Id?: string;
    NodeKey?: Plegma.NodeKey;
  }
  export interface ScheduleDescriptor {
    CreatedDate?: Date;
    Description?: string;
    Duration?: number;
    EndDate?: string;
    EndDateUtc?: number;
    EndTimeUnspecified?: boolean;
    Period?: number;
    Recurrence?: Plegma.eRecurrence;
    RecurrenceStr?: string;
    ReminderType?: Plegma.ReminderType;
    ScheduleKey?: Plegma.ScheduleKey;
    SpecificDayIds?: number[];
    SpecificDays?: number;
    StartDate?: string;
    StartDateUtc?: number;
    StartTime?: string;
    StartTimeUtc?: number;
    StopTime?: string;
    StopTimeUtc?: number;
    Title?: string;
    Type?: string;
  }
  export interface ScheduleNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    ScheduleKey?: Plegma.ScheduleKey;
    ScheduleTitle?: string;
  }
  export interface ServiceNodeDescriptor {
    CreationDate?: string;
    Email?: string;
    LastActivity?: string;
    NodeKey?: string;
  }
  export interface SetAlertPercentage extends Warlock.WarlockApiMsg {
    newPercentage?: number;
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface SetAlertPercentageForAllQuota extends Warlock.WarlockApiMsg {
    newPercentage?: number;
    targetUkey?: Plegma.UserKey;
  }
  export interface SetDefyQuotaFlag extends Warlock.WarlockApiMsg {
    newValue?: boolean;
    targetNKey?: string;
    targetUkey?: Plegma.UserKey;
  }
  export interface SetMetadataReq {
    Files?: Warlock.FileMetadata[];
  }
  export interface SetMetadataRsp extends Warlock.GenericRsp {
    Responses?: { [key: string]: Warlock.GenericRsp };
  }
  export interface SetQuotaCurrentValue extends Warlock.WarlockApiMsg {
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
    value?: number;
  }
  export interface SetQuotaFlags extends Warlock.WarlockApiMsg {
    flagsToSet?: Warlock.eQuotaFlags;
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface SetQuotaLimit extends Warlock.WarlockApiMsg {
    limit?: number;
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface SetQuotaPeriodTimespan extends Warlock.WarlockApiMsg {
    period?: any;
    targetKey?: string;
    targetUkey?: Plegma.UserKey;
    type?: Warlock.eQuotaType;
  }
  export interface SetUserSettings extends Warlock.WarlockApiMsg {
    email?: string;
    SharingOption?: string;
    TimeZoneid?: string;
  }
  export interface ShareActionReq {
    Direction?: Plegma.ioPortDirection;
    Id?: number;
    PendingToken?: string;
    TargetUserToken?: string;
    ThingKey?: string;
    Type?: Warlock.eShareActionType;
  }
  export interface ShareActionRsp extends Warlock.GenericRsp {
    Id?: number;
    Info?: Warlock.ShareInfo[];
    IsPending?: boolean;
    PendingToken?: string;
    ThingKeysByOthers?: { [key: string]: string[] };
    ThingKeysToOthers?: { [key: string]: string[] };
  }
  export interface SharedGraphConfigReq extends Warlock.WarlockApiMsg {
    request?: Warlock.SharedGraphConfReq;
  }
  export interface SharedGraphConfReq extends Warlock.GenericRsp {
    FoundThingsAction?: Warlock.eFoundThingsAction;
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    GraphName?: string;
    GraphPath?: string;
    NotificationDescriptorKey?: Warlock.NotificationDescriptorKey;
    OverwriteGraph?: boolean;
    PendingToken?: string;
    RequesterEmail?: string;
    Step?: number;
    ThingKeysReplacement?: { [key: string]: Plegma.ThingKey };
  }
  export interface SharedGraphConfRsp extends Warlock.GenericRsp {
    Errors?: { [key: string]: string };
    IsFinished?: boolean;
    ThingDescriptors?: { [key: string]: Warlock.ThingDescriptor };
    ThingTypes?: string[];
    ThingTypeToThingKeys?: { [key: string]: Plegma.ThingKey[] };
  }
  export interface SharedGraphNecessaryThings {
    Direction?: Plegma.ioPortDirection;
    Key?: Plegma.ThingKey;
    Name?: string;
  }
  export interface ShareGraphActionReq extends Warlock.WarlockApiMsg {
    request?: Warlock.ShareGraphReq;
  }
  export interface ShareGraphReq {
    GraphDescriptorKey?: Plegma.GraphDescriptorKey;
    NotificationDescriptorKey?: Warlock.NotificationDescriptorKey;
    PendingToken?: string;
    RequesterEmail?: string;
    Type?: Warlock.eShareActionType;
  }
  export interface ShareInfo {
    Direction?: Plegma.ioPortDirection;
    Email?: string;
    Enabled?: boolean;
  }
  export interface ShareNotification {
    IsSuccessful?: boolean;
    PendingToken?: string;
    RequestingUserToken?: string;
    TargetUserToken?: string;
    ThingKey?: string;
    Type?: Warlock.eShareActionType;
  }
  export interface ShareNotifyMsg extends Warlock.WarlockApiMsg {
    Notifications?: Warlock.ShareNotification[];
  }
  export interface ShareThingsReq extends Warlock.WarlockApiMsg {
    ShareActionReqs?: Warlock.ShareActionReq[];
  }
  export interface ShareThingsRsp extends Warlock.GenericRsp {
    Handled?: boolean;
    ShareActionRsps?: Warlock.ShareActionRsp[];
  }
  export interface SingleFileResp extends Warlock.GenericRsp {
    ContentType?: string;
    Description?: string;
    Guid?: string;
    LocationDescriptorJson?: string;
    Name?: string;
    Size?: number;
    Url?: string;
  }
  export interface SipAccount {
    secret?: string;
    user?: string;
  }
  export interface SocialAccountsRsp extends Warlock.GenericRsp {
    SocialAccounts?: Warlock.UserSocialAccountsDescriptor;
  }
  export interface StorageReplaceReq extends Warlock.WarlockApiMsg {
    fdescription?: string;
    fname?: string;
    guid?: string;
    length?: number;
  }
  export interface StorageUploadReq extends Warlock.WarlockApiMsg {
    fdescription?: string;
    fname?: string;
    length?: number;
  }
  export interface StorageUploadResp extends Warlock.GenericRsp {
    AccessToken?: string;
    guid?: string;
    Uploaduri?: string;
    UserToken?: string;
    WorkerKey?: string;
    WorkerUri?: string;
  }
  export interface TestAddRestServiceReq extends Warlock.WarlockApiMsg {
    jsonrestservice?: string;
  }
  export interface ThingDescriptor {
    BlockType?: string;
    ConfFlags?: Plegma.eThingConf;
    Config?: Plegma.ConfigParameter[];
    Email?: string;
    Hidden?: boolean;
    Hierarchy?: string;
    Img?: string;
    InGraphs?: boolean;
    Name?: string;
    NodeType?: Plegma.eNodeType;
    Owned?: boolean;
    Ports?: Warlock.PortDescriptor[];
    ReadOnlyInfo?: Plegma.ConfigParameter[];
    Removable?: boolean;
    RESTUri?: string;
    Shared?: boolean;
    Tags?: string[];
    ThingKey?: Plegma.ThingKey;
    Type?: string;
    UIHints?: Plegma.ThingUIHints;
  }
  export interface ThingIngestStateReq extends Warlock.WarlockApiMsg {
    PortEvMsg?: Plegma.PortEventMsg;
    Rpc?: boolean;
  }
  export interface ThingNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    Name?: string;
    Owner?: string;
    ThingKey?: Plegma.ThingKey;
  }
  export interface ThingSetStateReq extends Warlock.WarlockApiMsg {
    PortEvMsg?: Plegma.PortEventMsg;
    Rpc?: boolean;
  }
  export interface ThingSetStateRsp extends Warlock.WarlockApiMsg {
    BlockKey?: string;
    IsSuccess?: boolean;
    Message?: string;
    PortEvents?: Plegma.PortEvent[];
  }
  export interface ThingShareInfoDescriptor {
    Info?: Warlock.ShareInfo[];
    Name?: string;
    Owned?: boolean;
    OwnerEmail?: string;
    PortsLength?: number;
    Removable?: boolean;
    ThingKey?: Plegma.ThingKey;
    Type?: string;
  }
  export interface ThingTimelineInfo extends Warlock.TimelineInfo {
    Name?: string;
  }
  export interface ThingTypeDescriptor {
    Description?: string;
    Img?: string;
    Model?: { [key: string]: Plegma.ThingModelType };
    Nodes?: Warlock.NodeDescriptor[];
    Searchable?: boolean;
    Type?: string;
  }
  export interface TimelineDescriptor {
    DateTimeTS?: Date;
    Info?: any;
    Message?: string;
    Operation?: Warlock.eTimelineDescriptorOperationType;
    TimelineDescriptorKey?: Warlock.TimelineDescriptorKey;
    Type?: Warlock.eTimelineDescriptorType;
  }
  export interface TimelineDescriptorKey {
    Id?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface TimelineDescriptorsQuery {
    ColumnsSearch?: { [key: string]: string };
    CurrentPage?: number;
    OrderDescending?: boolean;
    Ordering?: Warlock.eTimelineDescriptorsColumns;
    PageSize?: number;
    SearchText?: string;
  }
  export interface TimelineInfo {
    Key?: string;
  }
  export interface TimezoneHelpers {
  }
  export interface TLDUserAdd extends Warlock.WarlockApiMsg {
    request?: Warlock.TLDUserAddReq;
  }
  export interface TLDUserAddReq extends Warlock.DomainUserInfo {
    IsPLT?: boolean;
    Tld?: string;
  }
  export interface TLDUserAddRsp extends Warlock.GenericRsp {
  }
  export interface TLDUserRemove extends Warlock.WarlockApiMsg {
    request?: Warlock.TLDUserRemoveReq;
  }
  export interface TLDUserRemoveReq {
    Tld?: string;
  }
  export interface TLDUserRemoveRsp extends Warlock.GenericRsp {
  }
  export interface ToastrDescriptor {
    ExtendedTimeOut?: number;
    ProgressBar?: boolean;
    TimeOut?: number;
    Title?: string;
  }
  export interface TokenResponse {
    access_token?: string;
    expires_in?: number;
    refresh_token?: string;
    token_type?: string;
  }
  export interface UnpairNodeReq extends Warlock.WarlockApiMsg {
    Nodekey?: Plegma.NodeKey;
  }
  export interface UnRegisterUserKey extends Warlock.WarlockApiMsg {
    Userkeys?: Plegma.UserKey[];
  }
  export interface UpdateGroup extends Warlock.WarlockApiMsg {
    autoUpdate?: boolean;
    groupKey?: Plegma.GroupKey;
    hierarchy?: string;
    icon?: string;
    name?: string;
    tags?: string[];
    type?: string;
  }
  export interface UpdateLinkedUserReq extends Warlock.WarlockApiMsg {
    linkedUserDescriptor?: Warlock.LinkedUserDescriptor;
  }
  export interface UpdateThingReq extends Warlock.WarlockApiMsg {
    Config?: Plegma.ConfigParameter[];
    Hierarchy?: string;
    IconURI?: string;
    Name?: string;
    Tags?: string[];
    ThingKey?: Plegma.ThingKey;
    Type?: string;
    updateinfo?: Warlock.UpdateInfo;
  }
  export interface uploadCallback {
    UserToken?: string;
    WorkerApiKey?: string;
    WorkerUri?: string;
  }
  export interface UploadFilesResp extends Warlock.GenericRsp {
    FileResponses?: Warlock.SingleFileResp[];
  }
  export interface UploadRequest {
    BinaryResourceDescriptorKey?: Plegma.BinaryResourceDescriptorKey;
    ContentDescriptorJson?: string;
    FriendlyDescription?: string;
    FriendlyName?: string;
    Guid?: string;
    HttpContentType?: string;
    LocationDescriptorJson?: string;
    Size?: number;
    Uri?: string;
  }
  export interface UserConstantRequest extends Warlock.WarlockApiMsg {
    overWrite?: boolean;
    reqType?: Warlock.eUserConstantRequest;
    userConstants?: { [key: string]: Warlock.ConstantDescriptor };
  }
  export interface UserConstantsRsp extends Warlock.GenericRsp {
    ConstantExists?: boolean;
    UserConstants?: { [key: string]: Warlock.ConstantDescriptor };
  }
  export interface UserDescriptor {
    AccountLevel?: number;
    AccountLocked?: boolean;
    AvatarUri?: string;
    DefaultAppDomain?: string;
    Domain?: string;
    Email?: string;
    EnabledPackages?: string[];
    FirstName?: string;
    IgnoreQuota?: boolean;
    InMemory?: boolean;
    LastName?: string;
    LoggedIn?: boolean;
    Name?: string;
    Options?: Warlock.UserOptions;
    PrivelegeLevel?: Warlock.ePrivilegeLevel;
    ReadVersion?: string;
    Request?: Warlock.RouteRequest;
    SubUserKey?: Plegma.SubUserKey;
    TimeZoneId?: string;
    Token?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface UserFacebookDescriptor extends Warlock.ServiceNodeDescriptor {
  }
  export interface UserFacebookInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    email?: string;
    jid?: string;
    name?: string;
  }
  export interface UserFirebaseDBDescriptor {
    email?: string;
    tokenresponse?: Warlock.TokenResponse;
  }
  export interface UserGmailDescriptor {
    email?: string;
    tokenresponse?: Warlock.TokenResponse;
  }
  export interface UserGsheetsDescriptor {
    email?: string;
    tokenresponse?: Warlock.TokenResponse;
  }
  export interface UserHangoutsDescriptor {
    Email?: string;
    Jid?: string;
    Name?: string;
    PendingInvitation?: boolean;
  }
  export interface UserHangoutsInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    email?: string;
    jid?: string;
    name?: string;
  }
  export interface UserInfo {
    Avatar?: string;
    Email?: string;
    LoggedIn?: boolean;
    Name?: string;
    Username?: string;
    UserToken?: string;
  }
  export interface UserInfoResponse {
    AccountLevel?: number;
    Avatar?: string;
    Email?: string;
    LoggedIn?: boolean;
    PrivateToken?: string;
    PublicToken?: string;
    Username?: string;
  }
  export interface UserIrcDescriptor {
    Nickname?: string;
    SubscribedChannels?: string[];
  }
  export interface UserIrcInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    nickname?: string;
    subscribedchannels?: string[];
  }
  export interface UserLoginReq extends Warlock.WarlockApiMsg {
    Email?: string;
    IsDemoLogin?: boolean;
    Name?: string;
    PasswordHash?: string;
  }
  export interface UserLoginRsp extends Warlock.GenericRsp {
    UserDescriptor?: Warlock.UserDescriptor;
    UserIsLocked?: boolean;
    UserIsNew?: boolean;
  }
  export interface UserLyncDescriptor {
    AssignedB2BLyncBot?: number;
    AssignedIMBot?: number;
    AssignedListenerBot?: number;
    AssignedOutgoingBot?: number;
    AssignedSipBot?: number;
    IOPSip?: boolean;
    LyncUsername?: string;
    PendingInvitation?: boolean;
  }
  export interface UserLyncInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    IOPSip?: boolean;
    lyncusername?: string;
  }
  export interface UserMessage {
    Message?: string;
    TimestampStr?: string;
    Type?: Warlock.eUserMessageType;
  }
  export interface UserOptions {
    SharingOpts?: Warlock.eSharingOpts;
  }
  export interface UserQuotaDescriptor {
    DefiesQuota?: boolean;
    NodeKey?: string;
    Quota?: { [key: string]: Warlock.QuotaDescriptor };
    UserApiKey?: string;
    UserKey?: string;
  }
  export interface UserSipDescriptor {
    AssignedB2BLyncBot?: number;
    AssignedListenerBot?: number;
    AssignedOutgoingBot?: number;
    Host?: string;
    IOPLync?: boolean;
    IsActivated?: boolean;
    PendingInvitation?: boolean;
    Pin?: string;
    Secret?: string;
    SipUsername?: string;
  }
  export interface UserSipInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    IOPLync?: boolean;
    sipusername?: string;
  }
  export interface UserSkypeDescriptor extends Warlock.ServiceNodeDescriptor {
  }
  export interface UserSkypeInfoNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    msmail?: string;
  }
  export interface UserSMTPSetRequest extends Warlock.WarlockApiMsg {
    SMTP_Password?: string;
    SMTP_Server?: string;
    SMTP_ServerPort?: number;
    SMTP_Username?: string;
  }
  export interface UserSocialAccountsDescriptor {
    Facebook?: Warlock.UserFacebookDescriptor[];
    FirebaseDB?: Warlock.UserFirebaseDBDescriptor[];
    Gmail?: Warlock.UserGmailDescriptor[];
    Gsheets?: Warlock.UserGsheetsDescriptor[];
    Hangout?: Warlock.UserHangoutsDescriptor[];
    Irc?: Warlock.UserIrcDescriptor[];
    Lync?: Warlock.UserLyncDescriptor[];
    RestService?: Warlock.ConfiguredRestServiceDescriptor[];
    Sip?: Warlock.UserSipDescriptor[];
    Skype?: Warlock.UserSkypeDescriptor[];
  }
  export interface UserTimelineInfo extends Warlock.TimelineInfo {
    AccountLevel?: number;
    PrivilegeLevel?: Warlock.ePrivilegeLevel;
    ReasonCode?: number;
    ReasonMsg?: string;
  }
  export interface UserUploadReqMetaData {
    ADomainID?: string;
    SubUserKey?: string;
  }
  export interface ValidateBlockConfigurationRsp extends Warlock.GenericRsp {
    HasErrors?: boolean;
    UID?: number;
    ValidationResults?: Warlock.ValidationResDescriptor[];
  }
  export interface ValidationResDescriptor {
    Msg?: string;
    Type?: Warlock.ResultType;
  }
  export interface ValidationResultDescriptor extends Warlock.GenericRsp {
  }
  export interface WarlockApiMsg extends Yodiwo.API.ApiMsg {
    AppDomainID?: string;
    SubUserKey?: Plegma.SubUserKey;
    TargetSubUserKey?: string;
    UserKey?: Plegma.UserKey;
  }
  export interface WarlockApiMsgOrigin {
    AppDomainID?: string;
    SubUserKey?: Plegma.SubUserKey;
    TargetSubUserKey?: string;
  }
  export interface WarlockAuthenticationRequest extends Warlock.WarlockApiMsg {
  }
  export interface WarlockAuthenticationResponse extends Warlock.WarlockApiMsg {
    Secret?: string;
  }
  export interface WebSocketMsg extends Warlock.WrapperMsg {
    Id?: Warlock.eWSMsgId;
    SubId?: string;
  }
  export interface WorkerEventNotification extends Warlock.WarlockApiMsg {
    Data?: any;
    MsgType?: Warlock.EventMsgType;
    Response?: Plegma.GenericRsp;
  }
  export interface YThingNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    Name?: string;
    Owner?: string;
    RequesterEmail?: string;
    ThingKey?: Plegma.ThingKey;
  }
  export interface YThingTypeNotificationInfo extends Warlock.NotificationDescriptorRelatedObject {
    NodeKey?: Plegma.NodeKey;
  }
}
//----------------------------------------------- 
export module Yodiwo {
  export interface WrapperMsg {
    Flags?: Plegma.eMsgFlags;
    Payload?: string;
    PayloadSize?: number;
    SyncId?: number;
  }
}
//----------------------------------------------- 
export module Yodiwo.API {
  export interface ApiMsg {
    SeqNo?: number;
  }
  export interface EvCommon {
    IsGlobalEvent?: boolean;
    Message?: string;
    ReportIt?: boolean;
    SendToServices?: boolean;
  }
}
//----------------------------------------------- 
export module Plegma {
  export interface DbDocument<T> {
  }
  export interface GenericRsp extends Plegma.PlegmaApiMsg {
    IsSuccess?: boolean;
    Message?: string;
    OrigSeqNo?: number;
    StatusCode?: number;
  }
}
//----------------------------------------------- 
export module Services {
  export interface GenericExtServiceWrapperMQTT extends Yodiwo.WrapperMsg {
    TopicSuffix?: string;
  }
}
//----------------------------------------------- 
export module Services.DeviceMgmt {
  export interface GenericRsp {
    IsSuccess?: boolean;
    Message?: string;
    TokenId?: string;
  }
}
//----------------------------------------------- 
export module Services.Impact {
  export interface GenericRsp extends Plegma.GenericRsp {
    ImpactKey?: Services.ImpactKey;
  }
}
//----------------------------------------------- 
export module Warlock {
  export const enum eUserPrivilegeLevel {
    None = 0,
    ReadOnly = 1,
    WriteOnly = 2,
    All = 3
  }
  export interface GenericRsp extends Warlock.WarlockApiMsg {
    IsSuccess?: boolean;
    Message?: string;
    StatusCode?: number;
  }
  export interface WrapperMsg {
    Flags?: Warlock.eMsgFlags;
    Payload?: string;
    PayloadSize?: number;
    SyncId?: number;
  }
}
